/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import PropTypes from 'prop-types';

const AboutUsThread = ({ width, height }) => {
  return (
    <svg
      id="freepik_stories-about-us-page"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 750 500"
      version="1.1"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      css={css`
        max-width: ${width || '100%'};
        max-height: ${height || '100%'};
        height: ${height || '100%'};
        width: ${width || '100%'};
        display: inline-block;
      `}
    >
      <style
        dangerouslySetInnerHTML={{
          __html:
            'svg#freepik_stories-about-us-page:not(.animated) .animable {opacity: 0;}svg#freepik_stories-about-us-page.animated #freepik--background-complete--inject-43 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedRight;animation-delay: 0s;}svg#freepik_stories-about-us-page.animated #freepik--Page--inject-43 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown;animation-delay: 0s;}svg#freepik_stories-about-us-page.animated #freepik--speech-bubble--inject-43 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomIn;animation-delay: 0s;}svg#freepik_stories-about-us-page.animated #freepik--character-1--inject-43 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomIn;animation-delay: 0s;}svg#freepik_stories-about-us-page.animated #freepik--character-2--inject-43 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomOut;animation-delay: 0s;}svg#freepik_stories-about-us-page.animated #freepik--character-3--inject-43 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomOut;animation-delay: 0s;}svg#freepik_stories-about-us-page.animated #freepik--character-4--inject-43 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideRight;animation-delay: 0s;}            @keyframes lightSpeedRight {              from {                transform: translate3d(50%, 0, 0) skewX(-20deg);                opacity: 0;              }              60% {                transform: skewX(10deg);                opacity: 1;              }              80% {                transform: skewX(-2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes slideDown {                0% {                    opacity: 0;                    transform: translateY(-30px);                }                100% {                    opacity: 1;                    transform: translateY(0);                }            }                    @keyframes zoomIn {                0% {                    opacity: 0;                    transform: scale(0.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }                    @keyframes zoomOut {                0% {                    opacity: 0;                    transform: scale(1.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }                    @keyframes slideRight {                0% {                    opacity: 0;                    transform: translateX(30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }        .animator-hidden { display: none; }',
        }}
      />
      <g
        id="freepik--background-complete--inject-43"
        style={{ transformOrigin: '325.0700263977051px 201.9749870300293px' }}
        className="animable"
      >
        <path
          d="M598.94,354.43c0-1.59-.07-117.47-.19-304.89l.19.2-547.8.06h0l.26-.26c0,107.8,0,210.93,0,304.89l-.24-.24,547.84.24-547.84.24h-.24v-.24c0-94,0-197.09,0-304.89v-.26h.3l547.8.06h.2v.2C599,237,599,352.84,598.94,354.43Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '325.0700263977051px 201.9749870300293px',
          }}
          id="eldw6izi0eicn"
          className="animable"
        />
        <rect
          x="51.1"
          y="49.54"
          width="547.85"
          height="23.35"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '325.02500000000003px 61.215px',
          }}
          id="elicwtm17hye"
          className="animable"
        />
        <path
          d="M69,60.52a3.77,3.77,0,1,1-3.76-3.77A3.76,3.76,0,0,1,69,60.52Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '65.23000168800354px 60.51998710632324px',
          }}
          id="elgycklzlijrm"
          className="animable"
        />
        <path
          d="M80.64,60.52a3.77,3.77,0,1,1-3.76-3.77A3.76,3.76,0,0,1,80.64,60.52Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '76.87000465393066px 60.51998710632324px',
          }}
          id="elrvkgj18d8c7"
          className="animable"
        />
        <path
          d="M92.3,60.52a3.77,3.77,0,1,1-3.77-3.77A3.76,3.76,0,0,1,92.3,60.52Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '88.53001308441162px 60.51999759674072px',
          }}
          id="els8efqe1378q"
          className="animable"
        />
      </g>
      <g
        id="freepik--Page--inject-43"
        style={{ transformOrigin: '369.2300338745117px 280.75000762939453px' }}
        className="animable animator-hidden"
      >
        <rect
          x="92.17"
          y="96.12"
          width="554.08"
          height="369.38"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '369.21000000000004px 280.81px',
          }}
          id="elt0fpldkqyxd"
          className="animable"
        />
        <rect
          x="92.17"
          y="96.12"
          width="554.08"
          height="23.61"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '369.21000000000004px 107.92500000000001px',
          }}
          id="elsp0jwlor74l"
          className="animable"
        />
        <path
          d="M646.25,119.73c0-.48,0-7.45-.07-23.61l.07.07-554,.19h0l.26-.26v23.61l-.26-.26,554.08.26L92.17,120h-.26V95.86h.29l554.05.19h.07v.07C646.27,112.28,646.25,119.25,646.25,119.73Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '369.1200180053711px 107.93000030517578px',
          }}
          id="elboy8th74d8n"
          className="animable"
        />
        <path
          d="M110.27,107.22a3.81,3.81,0,1,1-3.81-3.81A3.81,3.81,0,0,1,110.27,107.22Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '106.45999526977539px 107.22000885009766px',
          }}
          id="elwbesnb30fb"
          className="animable"
        />
        <path
          d="M122.05,107.22a3.81,3.81,0,1,1-3.81-3.81A3.8,3.8,0,0,1,122.05,107.22Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '118.24001598358154px 107.22000026702881px',
          }}
          id="el1vi0cqr7ubzi"
          className="animable"
        />
        <path
          d="M133.84,107.22a3.81,3.81,0,1,1-3.81-3.81A3.81,3.81,0,0,1,133.84,107.22Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '130.0299949645996px 107.22000885009766px',
          }}
          id="elna1zzfzol9c"
          className="animable"
        />
        <path
          d="M247.71,188h-22l-4.2,10.16H210.27l21.12-47.4h10.84l21.19,47.4H251.91Zm-3.45-8.33-7.52-18.15-7.51,18.15Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '236.8449935913086px 174.4600067138672px',
          }}
          id="el5h712j5fi4"
          className="animable"
        />
        <path
          d="M307.31,179.9c0,11.45-7.93,18.76-18.15,18.76-4.88,0-8.81-1.56-11.45-4.74v4.2H267.62V147.87h10.57v17.68c2.71-3,6.43-4.4,11-4.4C299.38,161.15,307.31,168.46,307.31,179.9Zm-10.7,0c0-6.29-4-10.09-9.28-10.09s-9.28,3.8-9.28,10.09,4,10.09,9.28,10.09S296.61,186.2,296.61,179.9Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '287.4649963378906px 173.2649917602539px',
          }}
          id="eldmes8b02c1"
          className="animable"
        />
        <path
          d="M311.64,179.9c0-11,8.46-18.75,20-18.75s20,7.78,20,18.75-8.4,18.76-20,18.76S311.64,190.87,311.64,179.9Zm29.32,0c0-6.29-4-10.09-9.28-10.09s-9.34,3.8-9.34,10.09S326.4,190,331.68,190,341,186.2,341,179.9Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '331.6400146484375px 179.90499114990234px',
          }}
          id="eloqh9nocullj"
          className="animable"
        />
        <path
          d="M395.41,161.69v36.43h-10v-4.33a14.72,14.72,0,0,1-11.3,4.87c-9.15,0-15.58-5.14-15.58-16.39V161.69h10.56v19c0,6.09,2.71,8.8,7.39,8.8,4.87,0,8.39-3.12,8.39-9.82v-18Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '376.9700164794922px 180.16717338562012px',
          }}
          id="ellxm96w88o7"
          className="animable"
        />
        <path
          d="M428.72,196.36a15.06,15.06,0,0,1-8.6,2.3c-8.6,0-13.61-4.4-13.61-13.07v-15h-5.62V162.5h5.62v-8.87h10.57v8.87h9.07v8.13h-9.07v14.83c0,3.11,1.69,4.8,4.53,4.8a7.12,7.12,0,0,0,4.27-1.35Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '414.8050079345703px 176.15064811706543px',
          }}
          id="elv6xoldp4q4h"
          className="animable"
        />
        <path
          d="M490.55,161.69v36.43h-10v-4.33a14.75,14.75,0,0,1-11.31,4.87c-9.14,0-15.58-5.14-15.58-16.39V161.69h10.57v19c0,6.09,2.71,8.8,7.38,8.8,4.88,0,8.4-3.12,8.4-9.82v-18Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '472.10499572753906px 180.16712951660156px',
          }}
          id="el305t21npds2"
          className="animable"
        />
        <path
          d="M496.85,194.73l3.52-7.58A24.9,24.9,0,0,0,513,190.67c4.88,0,6.71-1.29,6.71-3.32,0-6-22,.14-22-14.42,0-6.91,6.23-11.78,16.86-11.78,5,0,10.57,1.15,14,3.18l-3.52,7.52a20.85,20.85,0,0,0-10.5-2.71c-4.74,0-6.77,1.49-6.77,3.38,0,6.23,22,.21,22,14.56,0,6.77-6.3,11.58-17.2,11.58C506.47,198.66,500.23,197,496.85,194.73Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '513.3150177001953px 179.90499114990234px',
          }}
          id="el9kq2ah4wlai"
          className="animable"
        />
        <path
          d="M582.26,465.47C560.88,443,529.49,432,498.44,432.22c-22.68.15-46.34,6.92-67.41-1.44-19.51-7.74-31.89-26.53-47.06-41a128.49,128.49,0,0,0-87.36-35.14c-21.82-.07-45.84,4.94-63.84-7.4-12.14-8.33-18.35-22.68-26.88-34.69-25-35.21-73.13-49.89-113.41-34.33l0,187Z"
          style={{
            fill: 'rgb(235, 235, 235)',
            transformOrigin: '337.3699951171875px 368.7543487548828px',
          }}
          id="el728b7mamn0o"
          className="animable"
        />
        <path
          d="M646.25,465.5c0-1.7-.08-144.19-.21-369.38l.21.21-554,0h0l.26-.26c0,131.54,0,256.66,0,369.38l-.24-.24,554.08.24-554.08.24h-.24v-.24c0-112.72,0-237.84,0-369.38v-.26h.31l554,0h.21v.21C646.33,321.31,646.25,463.8,646.25,465.5Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '369.29003143310547px 280.75000762939453px',
          }}
          id="elx6sdefizo7d"
          className="animable"
        />
        <path
          d="M161.58,176.92c0,.37-2.72.68-6.09.68s-6.09-.31-6.09-.68,2.73-.67,6.09-.67S161.58,176.55,161.58,176.92Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '155.49000549316406px 176.92499542236328px',
          }}
          id="elpwna6il495a"
          className="animable"
        />
        <path
          d="M168.05,160.36c.37,0,.67,2.76.67,6.18s-.3,6.18-.67,6.18-.67-2.77-.67-6.18S167.68,160.36,168.05,160.36Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '168.0500030517578px 166.5399932861328px',
          }}
          id="elpf7615ih1i"
          className="animable"
        />
        <path
          d="M174.94,176.53c0-.38,2.72-.68,6.08-.68s6.09.3,6.09.68-2.72.67-6.09.67S174.94,176.9,174.94,176.53Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '181.0250015258789px 176.5250015258789px',
          }}
          id="elg3itqaqi3vo"
          className="animable"
        />
        <path
          d="M168.47,193.09c-.37,0-.67-2.77-.67-6.18s.3-6.18.67-6.18.67,2.77.67,6.18S168.84,193.09,168.47,193.09Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '168.47000122070312px 186.91000366210938px',
          }}
          id="elxvm846yn0as"
          className="animable"
        />
        <path
          d="M178.31,186c-.28.23-1.48-.73-2.68-2.17s-1.93-2.78-1.65-3,1.49.73,2.68,2.16S178.6,185.75,178.31,186Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '176.14632940292358px 183.41618657112122px',
          }}
          id="elmgkb724sh8"
          className="animable"
        />
        <path
          d="M177.74,167.2c.27.26-.53,1.49-1.77,2.74s-2.46,2.06-2.72,1.8.53-1.49,1.77-2.75S177.48,166.94,177.74,167.2Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '175.4964828491211px 169.46957349777222px',
          }}
          id="elrkmhab36vga"
          className="animable"
        />
        <path
          d="M163.78,172c-.23.28-1.38-.28-2.57-1.27s-1.94-2-1.71-2.3,1.39.28,2.58,1.27S164,171.7,163.78,172Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '161.63879895210266px 170.2114042043686px',
          }}
          id="elky0bvpin1y"
          className="animable"
        />
        <path
          d="M163.24,180.26c.27.26-.42,1.46-1.55,2.7s-2.26,2-2.53,1.78.41-1.45,1.54-2.69S163,180,163.24,180.26Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '161.19970560073853px 182.49458193778992px',
          }}
          id="elixgibltqp7"
          className="animable"
        />
        <path
          d="M505.18,144.87c0,.21-1.55.38-3.46.38s-3.46-.17-3.46-.38,1.55-.38,3.46-.38S505.18,144.66,505.18,144.87Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '501.7200012207031px 144.8699951171875px',
          }}
          id="elt2h5og01oc"
          className="animable"
        />
        <path
          d="M508.85,135.47c.21,0,.38,1.57.38,3.5s-.17,3.51-.38,3.51-.38-1.57-.38-3.51S508.64,135.47,508.85,135.47Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '508.8500061035156px 138.9749984741211px',
          }}
          id="el7qkvhg12zx"
          className="animable"
        />
        <path
          d="M512.76,144.64c0-.21,1.55-.38,3.46-.38s3.45.17,3.45.38-1.54.39-3.45.39S512.76,144.86,512.76,144.64Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '516.2150268554688px 144.6449966430664px',
          }}
          id="elru289axv5r"
          className="animable"
        />
        <path
          d="M509.09,154.05c-.21,0-.38-1.57-.38-3.51s.17-3.51.38-3.51.38,1.57.38,3.51S509.3,154.05,509.09,154.05Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '509.0899963378906px 150.54000854492188px',
          }}
          id="el4jkw9wobcv"
          className="animable"
        />
        <path
          d="M514.68,150c-.17.13-.85-.42-1.53-1.23s-1.09-1.58-.93-1.72.84.42,1.52,1.23S514.84,149.88,514.68,150Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '513.449666261673px 148.52378153800964px',
          }}
          id="elalgw1kra118"
          className="animable"
        />
        <path
          d="M514.35,139.35c.15.15-.3.85-1,1.56s-1.4,1.16-1.55,1,.3-.84,1-1.55S514.2,139.2,514.35,139.35Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '513.074994802475px 140.63175308704376px',
          }}
          id="elen05ei5z036"
          className="animable"
        />
        <path
          d="M506.43,142.07c-.14.16-.79-.16-1.46-.72s-1.11-1.14-1-1.3.79.15,1.46.71S506.56,141.91,506.43,142.07Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '505.2025771141052px 141.05959582328796px',
          }}
          id="elsfzszip0egi"
          className="animable"
        />
        <path
          d="M506.12,146.77c.15.14-.24.82-.88,1.53s-1.28,1.15-1.44,1,.24-.83.88-1.53S506,146.63,506.12,146.77Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '504.95839071273804px 148.03667902946472px',
          }}
          id="el7fjrzze7rh"
          className="animable"
        />
        <path
          d="M348.13,223.53a12.25,12.25,0,0,1-5.3,0,11.85,11.85,0,0,1,5.3,0Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '345.4800109863281px 223.52498054504395px',
          }}
          id="elzsa33uunz39"
          className="animable"
        />
        <path
          d="M351,216.32a12.57,12.57,0,0,1,0,5.37,12.17,12.17,0,0,1,0-5.37Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '350.9951114654541px 219.0050048828125px',
          }}
          id="elwetsqhad6j"
          className="animable"
        />
        <path
          d="M353.94,223.35a12.25,12.25,0,0,1,5.3,0,11.85,11.85,0,0,1-5.3,0Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '356.58998107910156px 223.35500621795654px',
          }}
          id="elmv7x16e74br"
          className="animable"
        />
        <path
          d="M351.13,230.56a12.62,12.62,0,0,1,0-5.38,12.62,12.62,0,0,1,0,5.38Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '351.12999153137207px 227.8699951171875px',
          }}
          id="el3j8uet9czdy"
          className="animable"
        />
        <path
          d="M355.41,227.47c-.12.1-.64-.32-1.16-.94s-.85-1.21-.72-1.32.65.32,1.17.94S355.54,227.37,355.41,227.47Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '354.4702906012535px 226.33875823020935px',
          }}
          id="eloykp14ytesp"
          className="animable"
        />
        <path
          d="M355.17,219.29c.11.12-.23.65-.77,1.2s-1.08.89-1.19.78.23-.65.77-1.19S355.05,219.18,355.17,219.29Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '354.1900050640106px 220.2803999185562px',
          }}
          id="eleipotfcii66"
          className="animable"
        />
        <path
          d="M349.09,221.38c-.1.12-.6-.12-1.12-.55s-.85-.88-.74-1,.6.12,1.12.55S349.19,221.25,349.09,221.38Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '348.15855222940445px 220.6050015091896px',
          }}
          id="el917oq9e5zb"
          className="animable"
        />
        <path
          d="M348.85,225c.12.11-.18.63-.67,1.17s-1,.89-1.1.78.18-.63.67-1.17S348.73,224.87,348.85,225Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '347.96814012527466px 225.97204703092575px',
          }}
          id="elcqcq0420nlf"
          className="animable"
        />
        <path
          d="M488.92,234.74c0,.21-1.55.38-3.46.38S482,235,482,234.74s1.54-.39,3.45-.39S488.92,234.53,488.92,234.74Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '485.4600067138672px 234.7350082397461px',
          }}
          id="ellymlwbgyp6"
          className="animable"
        />
        <path
          d="M492.59,225.33c.21,0,.38,1.57.38,3.51s-.17,3.51-.38,3.51-.38-1.57-.38-3.51S492.38,225.33,492.59,225.33Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '492.5899963378906px 228.83999633789062px',
          }}
          id="elgh6zpmbou9m"
          className="animable"
        />
        <path
          d="M496.5,234.51c0-.21,1.55-.38,3.46-.38s3.45.17,3.45.38-1.54.38-3.45.38S496.5,234.72,496.5,234.51Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '499.9550018310547px 234.50999450683594px',
          }}
          id="elskghbqwmvt"
          className="animable"
        />
        <path
          d="M492.83,243.92c-.21,0-.38-1.58-.38-3.51s.17-3.51.38-3.51.38,1.57.38,3.51S493,243.92,492.83,243.92Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '492.8299865722656px 240.41000366210938px',
          }}
          id="eli37u27zfwga"
          className="animable"
        />
        <path
          d="M498.42,239.88c-.17.14-.85-.41-1.53-1.22s-1.09-1.59-.93-1.72.84.41,1.52,1.22S498.58,239.75,498.42,239.88Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '497.1897165775299px 238.41123974323273px',
          }}
          id="elppi3kvr4e79"
          className="animable"
        />
        <path
          d="M498.09,229.22c.15.15-.3.84-1,1.55s-1.4,1.17-1.55,1,.3-.84,1-1.56S497.94,229.07,498.09,229.22Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '496.8150110244751px 230.49758422374725px',
          }}
          id="el57wxdskupi"
          className="animable"
        />
        <path
          d="M490.17,231.93c-.14.17-.79-.15-1.46-.71s-1.11-1.15-1-1.31.79.16,1.46.72S490.3,231.77,490.17,231.93Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '488.9425938129425px 230.9222184419632px',
          }}
          id="eliivg00k8xmg"
          className="animable"
        />
        <path
          d="M489.86,236.63c.15.15-.24.83-.88,1.53s-1.28,1.16-1.44,1,.24-.83.88-1.53S489.7,236.49,489.86,236.63Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '488.69838094711304px 237.89795184135437px',
          }}
          id="elx7rzvamtfnc"
          className="animable"
        />
        <path
          d="M306.68,145.48l.45,1.08a7.68,7.68,0,0,0,4.18,4.14l1.18.48-1.13.45a7.64,7.64,0,0,0-4.21,4.23l-.32.78-.48-1a7.59,7.59,0,0,0-4.27-3.87l-1-.38,1.34-.64a7.67,7.67,0,0,0,3.72-4Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '306.7849884033203px 151.05998992919922px',
          }}
          id="elfmaexqu4oqb"
          className="animable"
        />
        <path
          d="M131.05,226.4l.3.72a5.07,5.07,0,0,0,2.78,2.75l.78.32-.75.3a5.11,5.11,0,0,0-2.8,2.81l-.21.52-.32-.65a5.08,5.08,0,0,0-2.83-2.58l-.68-.24.89-.43a5.17,5.17,0,0,0,2.47-2.62Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '131.11499404907227px 230.11000061035156px',
          }}
          id="eljnnnccem41"
          className="animable"
        />
        <path
          d="M573.6,156.64l.29.72a5.15,5.15,0,0,0,2.78,2.76l.78.31-.74.31a5.08,5.08,0,0,0-2.81,2.8l-.21.53-.31-.66a5.09,5.09,0,0,0-2.84-2.57l-.68-.25.89-.43a5,5,0,0,0,2.47-2.62Z"
          style={{
            fill: 'rgb(224, 224, 224)',
            transformOrigin: '573.6549987792969px 160.35499572753906px',
          }}
          id="elluix73ykedi"
          className="animable"
        />
        <path
          d="M574.93,187l.45,1.08a7.66,7.66,0,0,0,4.18,4.15l1.18.47-1.13.46a7.67,7.67,0,0,0-4.22,4.22l-.31.79-.48-1a7.59,7.59,0,0,0-4.27-3.87l-1-.37,1.34-.65a7.65,7.65,0,0,0,3.72-3.94Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '575.0350036621094px 192.58499908447266px',
          }}
          id="elqgndruiagfr"
          className="animable"
        />
        <path
          d="M390.16,138.93l.21.51a3.59,3.59,0,0,0,2,1.94l.55.23-.53.21a3.58,3.58,0,0,0-2,2l-.15.37-.23-.46a3.54,3.54,0,0,0-2-1.82l-.48-.17.63-.31a3.59,3.59,0,0,0,1.75-1.85Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '390.2249755859375px 141.55998992919922px',
          }}
          id="elv6ih5jtmvra"
          className="animable"
        />
        <path
          d="M250.76,221.83l.27.65a4.58,4.58,0,0,0,2.52,2.5l.71.29-.68.27a4.58,4.58,0,0,0-2.54,2.55l-.19.48-.29-.6a4.62,4.62,0,0,0-2.58-2.33l-.62-.23.81-.39a4.66,4.66,0,0,0,2.25-2.38Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '250.81002044677734px 225.1999969482422px',
          }}
          id="el421j1aaanlf"
          className="animable"
        />
      </g>
      <g
        id="freepik--speech-bubble--inject-43"
        style={{ transformOrigin: '655.3419189453125px 243.59498596191406px' }}
        className="animable animator-hidden"
      >
        <path
          d="M655.32,196.59A42.49,42.49,0,0,0,626.2,270l-5.74,20.1,20.3-11.1a42.51,42.51,0,1,0,14.56-82.45Z"
          style={{
            fill: 'rgb(245, 245, 245)',
            transformOrigin: '655.3399200439453px 243.32500457763672px',
          }}
          id="eljfg42aqprsp"
          className="animable"
        />
        <path
          d="M655.32,196.59s.25,0,.76,0l2.22.09c.49,0,1,0,1.64.09l2,.29c.71.12,1.48.19,2.29.37l2.55.64a42,42,0,0,1,24.75,18.42l1.32,2.17c.38.76.76,1.54,1.14,2.33a40.95,40.95,0,0,1,4,16.11,44.41,44.41,0,0,1-.1,6c-.07,1-.28,2-.42,3-.08.51-.15,1-.23,1.53l-.39,1.52a40.24,40.24,0,0,1-4.87,11.89,42.69,42.69,0,0,1-20.71,17.69,43.52,43.52,0,0,1-29.17,1l-1.38-.48.21,0c-6.92,3.79-13.71,7.51-20.3,11.1l-.53.3.16-.59c2-6.93,3.91-13.65,5.75-20.1l.07.25a44.73,44.73,0,0,1-6.92-8.42,44.07,44.07,0,0,1-4.44-9.48,42.78,42.78,0,0,1-1.93-9.82c-.08-.81-.11-1.62-.12-2.42a21.31,21.31,0,0,1,0-2.4,32.69,32.69,0,0,1,.41-4.67A42.38,42.38,0,0,1,619,216.82a43.62,43.62,0,0,1,9.81-11.08l2.64-2,2.67-1.62a20.77,20.77,0,0,1,2.59-1.36c.86-.39,1.66-.84,2.5-1.14a43.88,43.88,0,0,1,8.64-2.45l3.22-.47,2.36-.1,1.45,0h.49l-.49,0-1.44.1-2.36.14-3.2.5a44.43,44.43,0,0,0-8.58,2.51c-.83.3-1.62.76-2.47,1.15a22.18,22.18,0,0,0-2.58,1.37L631.57,204,629,206a43.09,43.09,0,0,0-9.68,11,42,42,0,0,0-5.77,16.06,33.62,33.62,0,0,0-.4,4.63,20.75,20.75,0,0,0,0,2.37c0,.79,0,1.59.12,2.4a42.87,42.87,0,0,0,1.93,9.7,42.56,42.56,0,0,0,11.26,17.69l.11.1-.05.15c-1.83,6.44-3.75,13.16-5.72,20.1l-.37-.3,20.29-11.1.1-.06.12,0,1.37.47a42.89,42.89,0,0,0,28.81-1,42.26,42.26,0,0,0,20.49-17.47,39.91,39.91,0,0,0,4.84-11.75c.13-.5.26-1,.38-1.5l.24-1.52c.13-1,.34-2,.42-3a45.23,45.23,0,0,0,.11-5.92,40.49,40.49,0,0,0-3.91-16l-1.12-2.31-1.3-2.15a42,42,0,0,0-12.28-12.79,42.43,42.43,0,0,0-12.21-5.63l-2.54-.67c-.8-.18-1.57-.26-2.27-.39l-2-.31c-.6-.09-1.15-.08-1.63-.12l-2.22-.14C655.57,196.62,655.32,196.59,655.32,196.59Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '655.3419342041016px 243.59498596191406px',
          }}
          id="el882utnnti5y"
          className="animable"
        />
        <path
          d="M646,233.28h3l6.56-9.15v-6s4.65-.28,4.1,7.58,0,5.85,0,5.85,9.86,0,10.68.9c.6.62.87,10.42,1,15.74a5.75,5.75,0,0,1-4.07,5.79,4.43,4.43,0,0,1-1.07.14c-2.46,0-15-2-15-2H646Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '658.6736402511597px 236.12939643859863px',
          }}
          id="elvksdjv0aemc"
          className="animable"
        />
        <polygon
          points="637.43 231.63 639.28 252.19 644.43 252.19 644.43 232.04 637.43 231.63"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '640.9299926757812px 241.91000366210938px',
          }}
          id="elnsa3tl5wctq"
          className="animable"
        />
      </g>
      <g
        id="freepik--character-1--inject-43"
        style={{ transformOrigin: '189.08768463134766px 338.9064254760742px' }}
        className="animable"
      >
        <path
          d="M224.16,240.07c-.17,3.21-4.35,7.49-3.06,10.43,2.38,5.42,1,11.91-2.08,17s-7.69,9-12.22,12.78a102.34,102.34,0,0,0-2.05-23.55c-.5-2.42-1.32-5.12-3.53-6.22-2.87-1.42-6.51.63-9.45-.63-3.13-1.36-3.76-5.64-6.4-7.8-2.39-1.95-5.9-1.74-8.83-.76s-5.62,2.63-8.63,3.3-6.64.07-8.31-2.53c-1-1.6-.29-.62-1.27-2.25,0,0-5.87.2-7.89-6.63,0,0-2.76-7.59,3.35-10.94,0,0,1.39-13.72,15.18-7.55,4,1.78,8.66-3.94,12.53-2,3.22,1.63,4.17,6.11,7.39,7.75,3.7,1.88,8-.92,12.14-1.09a10,10,0,0,1,10,10s.65-2.74,5.14-1.54S224.48,233.81,224.16,240.07Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '186.99849700927734px 246.29642868041992px',
          }}
          id="ellcocd0lovmi"
          className="animable"
        />
        <path
          d="M218.31,262.15a9.7,9.7,0,0,0-.84-4.52c-.58-1.17-2.75-3.83-5.13-4l.35-14.13a5.63,5.63,0,0,0-5-5.7L180,230.88a16.87,16.87,0,0,0-18.61,15.72c-.67,10.65-1.07,23.68.19,31.62,2.54,16,14.78,18,14.78,18l-.3,11.16c-.47,11.89,8.43,19.05,17.61,19.05s17.66-7.93,17.39-19.7l.9-36a6.3,6.3,0,0,0,4.05-2A10.11,10.11,0,0,0,218.31,262.15Z"
          style={{
            fill: 'rgb(255, 190, 157)',
            transformOrigin: '189.5420436859131px 278.6082572937012px',
          }}
          id="el2ksj7gtmrbu"
          className="animable"
        />
        <path
          d="M167.53,255.27a2.06,2.06,0,0,0,2,2.07,2,2,0,0,0,2.11-1.85,2,2,0,0,0-2-2.07A2,2,0,0,0,167.53,255.27Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '169.58558988571167px 255.37998831272125px',
          }}
          id="elmfsok747dij"
          className="animable"
        />
        <path
          d="M164.17,253.38c.25.27,1.8-.88,4-.88s3.82,1.11,4.06.84c.11-.12-.15-.6-.85-1.11a5.6,5.6,0,0,0-3.25-1,5.32,5.32,0,0,0-3.19,1C164.27,252.78,164,253.26,164.17,253.38Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '168.18737888336182px 252.32519209384918px',
          }}
          id="elw34wmgmttr8"
          className="animable"
        />
        <path
          d="M188.81,255.68a2.05,2.05,0,0,0,2,2.07,2,2,0,0,0,2.11-1.85,2.05,2.05,0,0,0-2-2.07A2,2,0,0,0,188.81,255.68Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '190.86498928070068px 255.78999364376068px',
          }}
          id="elzbe5mu9oof9"
          className="animable"
        />
        <path
          d="M185.84,253.79c.25.27,1.8-.88,4-.87s3.82,1.1,4.06.83c.11-.12-.14-.6-.85-1.11a5.6,5.6,0,0,0-3.25-1,5.39,5.39,0,0,0-3.19,1C185.94,253.19,185.71,253.67,185.84,253.79Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '189.86505556106567px 252.73534560203552px',
          }}
          id="el2sfqlcxbd1f"
          className="animable"
        />
        <path
          d="M177.83,270.14a15.15,15.15,0,0,0-3.58-.65c-.56-.05-1.09-.17-1.19-.55a2.93,2.93,0,0,1,.38-1.67L175.1,263c2.32-6.11,4-11.13,3.74-11.22s-2.32,4.78-4.63,10.89c-.56,1.5-1.09,2.94-1.59,4.31a3.27,3.27,0,0,0-.3,2.21,1.42,1.42,0,0,0,.93.82,4,4,0,0,0,1,.14A13.82,13.82,0,0,0,177.83,270.14Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '175.55629563331604px 261.02012634277344px',
          }}
          id="el2vmigl4jr2r"
          className="animable"
        />
        <path
          d="M176.31,296.23a40.68,40.68,0,0,0,21.4-5.71s-5.54,12-21.53,10.53Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '186.94499969482422px 295.84742546081543px',
          }}
          id="el3bu9gtwd9yd"
          className="animable"
        />
        <path
          d="M184.84,249.93c.22.6,2.42.32,5,.63s4.68,1,5,.48c.15-.26-.21-.82-1.05-1.4a8.48,8.48,0,0,0-3.73-1.31,8.4,8.4,0,0,0-3.91.46C185.23,249.18,184.75,249.65,184.84,249.93Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '189.85122156143188px 249.74915981292725px',
          }}
          id="el5do61su2cvb"
          className="animable"
        />
        <path
          d="M163.81,248.25c.39.5,1.9,0,3.73,0s3.37.33,3.73-.19c.16-.26-.09-.76-.76-1.23a5.41,5.41,0,0,0-6,.19C163.85,247.49,163.64,248,163.81,248.25Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '167.535236120224px 247.2429839372635px',
          }}
          id="el1nqj22nun1f"
          className="animable"
        />
        <path
          d="M178.32,282.62c0-.05.15-.32.6-.6a3.87,3.87,0,0,1,2-.54,3.92,3.92,0,0,1,2,.52c.45.28.65.54.61.59a9.7,9.7,0,0,0-2.58-.58A8.86,8.86,0,0,0,178.32,282.62Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '180.92749953269958px 282.0498334169388px',
          }}
          id="elasc2b87zop8"
          className="animable"
        />
        <path
          d="M210.87,266.4a12.84,12.84,0,0,0,1.52-.74,4.1,4.1,0,0,0,1.85-3.28,4.19,4.19,0,0,0-1.66-3.41,3.51,3.51,0,0,0-1.52-.59c-.05-.06.74-.33,1.73.28a4.33,4.33,0,0,1,2,3.72,4.11,4.11,0,0,1-.74,2.29,4.27,4.27,0,0,1-1.44,1.31A2.49,2.49,0,0,1,210.87,266.4Z"
          style={{
            fill: 'rgb(235, 153, 110)',
            transformOrigin: '212.8302779197693px 262.34499979019165px',
          }}
          id="elkbnsyicxdb8"
          className="animable"
        />
        <path
          d="M158.33,227.07c-2.58,6.9,3.55,11.9,8.33,13,6.68,1.56,13.78-2.66,18.35-.87,3.41,1.34,6.63,4,10.25,3.45,1.76-.26,3.5-1.27,5.21-.81,2.19.6,3.08,3.26,3,5.53-.06,2.8-1,5.58-.65,8.36s2.83,5.65,5.54,4.91a6.66,6.66,0,0,0,4.54-6c.32-3.85-.39-8.43-.2-12.29.17-3.4.18-7.14-2-9.77s-5.86-3.34-9.25-3.8a257.38,257.38,0,0,0-43.16-2.28"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '185.3515796661377px 243.56608963012695px',
          }}
          id="eld228pex94fl"
          className="animable"
        />
        <path
          d="M149.92,228.54a2.22,2.22,0,0,1-.14-.72,4.24,4.24,0,0,1,.42-2.07,4.66,4.66,0,0,1,2.41-2.29,4.19,4.19,0,0,1,2.1-.23c.75.07,1.5.27,2.29.31a4.49,4.49,0,0,0,2.36-.52,11.36,11.36,0,0,0,2.19-1.59c.72-.62,1.45-1.3,2.29-1.91a7.45,7.45,0,0,1,2.94-1.29,10.85,10.85,0,0,1,6.69,1.14,31.47,31.47,0,0,1,5.92,4.23,23.18,23.18,0,0,0,5.91,4,6.81,6.81,0,0,0,3.25.5,9.28,9.28,0,0,0,3-1,28.17,28.17,0,0,1,5.56-2.56,11,11,0,0,1,5.36-.17,8.27,8.27,0,0,1,3.89,2.09,7.86,7.86,0,0,1,1.85,2.78,6.12,6.12,0,0,1,.41,2.07,3.82,3.82,0,0,1,0,.55q0,.18,0,.18a7.65,7.65,0,0,0-.54-2.72,7.76,7.76,0,0,0-1.86-2.65,8,8,0,0,0-3.77-1.94,10.74,10.74,0,0,0-5.16.22,28.27,28.27,0,0,0-5.47,2.58,9.42,9.42,0,0,1-3.2,1,7.26,7.26,0,0,1-3.49-.51,23.78,23.78,0,0,1-6.05-4.06,31.25,31.25,0,0,0-5.82-4.17,10.43,10.43,0,0,0-6.37-1.13c-2.09.35-3.6,1.82-5,3.06a11.72,11.72,0,0,1-2.29,1.61,4.94,4.94,0,0,1-2.57.54c-.83-.06-1.58-.27-2.3-.36a4.09,4.09,0,0,0-2,.18,4.52,4.52,0,0,0-2.33,2.11,4.35,4.35,0,0,0-.5,2C149.88,228.29,150,228.53,149.92,228.54Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '179.20214080810547px 225.0746364593506px',
          }}
          id="elumpi7mqh0k9"
          className="animable"
        />
        <path
          d="M157.65,239.66a1.3,1.3,0,0,1-.7,0,2.41,2.41,0,0,1-1.62-1.16,4.74,4.74,0,0,1-.38-3.14,9.06,9.06,0,0,1,1.64-3.87,8.68,8.68,0,0,1,4.07-3.06,9,9,0,0,1,5.83-.15,20.43,20.43,0,0,1,5.61,3.18,19.6,19.6,0,0,0,5.89,3.3,11.07,11.07,0,0,0,6.6-.36,31.55,31.55,0,0,0,5.73-2.73,51.46,51.46,0,0,1,5.15-2.71,14.62,14.62,0,0,1,4.92-1.27,9.14,9.14,0,0,1,6.85,2.3,6.09,6.09,0,0,1,1.18,1.62,2.81,2.81,0,0,1,.24.66,7.46,7.46,0,0,0-1.55-2.13,9.12,9.12,0,0,0-6.69-2.09,14.3,14.3,0,0,0-4.78,1.31,50.16,50.16,0,0,0-5.08,2.73,31.9,31.9,0,0,1-5.81,2.79,11.57,11.57,0,0,1-6.91.38,20.2,20.2,0,0,1-6-3.38,20.16,20.16,0,0,0-5.45-3.14,8.68,8.68,0,0,0-5.55.09,8.47,8.47,0,0,0-3.92,2.88,8.73,8.73,0,0,0-1.64,3.7,4.52,4.52,0,0,0,.27,3A2.36,2.36,0,0,0,157,239.6,3.82,3.82,0,0,0,157.65,239.66Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '181.74799919128418px 233.6834626197815px',
          }}
          id="elidg12586vm"
          className="animable"
        />
        <path
          d="M218.89,266.31s.36-.48.89-1.4a9.57,9.57,0,0,0,1.19-4.28,8.9,8.9,0,0,0-.38-3,11.38,11.38,0,0,0-1.6-3.14c-.7-1-1.53-2.1-2.26-3.3a7.68,7.68,0,0,1-1.31-4.16,10.21,10.21,0,0,1,1.34-4.15,8.83,8.83,0,0,0,1.12-3.68,6.29,6.29,0,0,0-2.95-5.49,6.54,6.54,0,0,0-4.29-.84,13.37,13.37,0,0,0-1.6.39,1.57,1.57,0,0,1,.37-.22,5.78,5.78,0,0,1,1.2-.37,6.52,6.52,0,0,1,4.5.72,6.63,6.63,0,0,1,3.25,5.82,9.33,9.33,0,0,1-1.14,3.89,9.78,9.78,0,0,0-1.28,3.94,7.17,7.17,0,0,0,1.23,3.89c.7,1.16,1.52,2.22,2.22,3.29a11.83,11.83,0,0,1,1.62,3.29,9.15,9.15,0,0,1,.33,3.18A9.3,9.3,0,0,1,220,265a6.54,6.54,0,0,1-.75,1C219,266.22,218.9,266.32,218.89,266.31Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '215.20190572738647px 249.42641067504883px',
          }}
          id="elmo182qvs5cg"
          className="animable"
        />
        <path
          d="M177,254.64a22.18,22.18,0,0,0-.42-2.49,10.15,10.15,0,0,0-13.29-7,10.24,10.24,0,0,0-4.65,3.51,10,10,0,0,0,0,11.85,9.17,9.17,0,0,0,2.12,2.14,9.3,9.3,0,0,0,2.53,1.37,10.08,10.08,0,0,0,9.54-1.4,10.3,10.3,0,0,0,3.75-5.55,22.71,22.71,0,0,0,.42-2.48,7.94,7.94,0,0,1-.22,2.53A10.25,10.25,0,0,1,173,263a10.43,10.43,0,0,1-9.92,1.56,9.69,9.69,0,0,1-2.67-1.42,10,10,0,0,1-2.23-2.23,10.45,10.45,0,0,1,0-12.46,10.56,10.56,0,0,1,4.9-3.66,10.54,10.54,0,0,1,5.52-.43,10.41,10.41,0,0,1,8.13,7.78A8,8,0,0,1,177,254.64Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '166.57074737548828px 254.67669773101807px',
          }}
          id="elc91qq75l6se"
          className="animable"
        />
        <path
          d="M200.44,254.64a19.57,19.57,0,0,0-.42-2.49,10.14,10.14,0,0,0-13.28-7,10.2,10.2,0,0,0-4.66,3.51,10,10,0,0,0,0,11.85,9.36,9.36,0,0,0,2.12,2.14,9.5,9.5,0,0,0,2.54,1.37A10.15,10.15,0,0,0,200,257.12a20,20,0,0,0,.42-2.48,7.59,7.59,0,0,1-.22,2.53A10.22,10.22,0,0,1,196.5,263a10.43,10.43,0,0,1-9.92,1.56,9.69,9.69,0,0,1-2.67-1.42,10.08,10.08,0,0,1-2.24-2.23,10.49,10.49,0,0,1,0-12.46,10.66,10.66,0,0,1,4.91-3.66,10.54,10.54,0,0,1,5.52-.43,10.42,10.42,0,0,1,8.12,7.78A7.65,7.65,0,0,1,200.44,254.64Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '190.04115390777588px 254.67667770385742px',
          }}
          id="elqgy493uxnhc"
          className="animable"
        />
        <path
          d="M180.44,252.92a0,0,0,0,1,0,0h0v.1h0l0,0h0v-.18h0v.2a6.81,6.81,0,0,1-1.68.16c-1,0-1.83-.12-1.83-.26s.82-.26,1.83-.26a6.34,6.34,0,0,1,1.68.16v.2h0v-.18h0l0,0h0v.1h0A0,0,0,0,1,180.44,252.92Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '178.68500518798828px 252.93912786245346px',
          }}
          id="elpb7zdey9au"
          className="animable"
        />
        <path
          d="M212.79,255.18a37.25,37.25,0,0,1-6.3-.19,37.55,37.55,0,0,1-6.26-.71,39.94,39.94,0,0,1,6.3.19A38.86,38.86,0,0,1,212.79,255.18Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '206.50999450683594px 254.73388648033142px',
          }}
          id="elikaypzn3eek"
          className="animable"
        />
        <path
          d="M187,269.59a2.71,2.71,0,0,1,.07,1.61,5.51,5.51,0,0,1-5.66,4.63,2.7,2.7,0,0,1-1.57-.39c0-.08.62.08,1.57,0a5.65,5.65,0,0,0,5.3-4.33C187,270.2,186.94,269.59,187,269.59Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '183.49999475479126px 272.7124786376953px',
          }}
          id="elqf33307s7sd"
          className="animable"
        />
        <path
          d="M147.39,341.38a1.34,1.34,0,0,1,0,.32l0,.94c0,.86,0,2.08.05,3.62,0,3.17,0,7.7.07,13.29,0,11.22-.34,26.72-1.21,43.82s-1.77,32.55-2.38,43.79c-.28,5.57-.51,10.1-.67,13.27q-.12,2.31-.18,3.6c0,.39-.05.7-.06.94a1.64,1.64,0,0,1,0,.32,1.14,1.14,0,0,1,0-.32c0-.24,0-.55,0-.94,0-.86.05-2.07.09-3.61.09-3.14.25-7.68.5-13.28.47-11.21,1.38-26.69,2.23-43.79s1.31-32.59,1.37-43.81c0-5.58.07-10.11.09-13.28,0-1.54,0-2.76.05-3.62l0-.94A1.34,1.34,0,0,1,147.39,341.38Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '145.25436305999756px 403.3350067138672px',
          }}
          id="elnuvvurv25tn"
          className="animable"
        />
        <path
          d="M244,324.16c-5.38-6.21-15.89-7.12-20.55-3.75s-7.25,9.09-7.72,14.82,1,11.48,3.18,16.79c3.51,8.52,8.7,15.42,16.45,24.2l20,26.22-38.55,37.64,16,25.21,32.77-26.4,27.1-28.72"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '254.1611328125px 391.8840560913086px',
          }}
          id="elrnmkq2rosj"
          className="animable"
        />
        <path
          d="M104.61,405a6.28,6.28,0,0,1,2.08-1,14.72,14.72,0,0,1,5.51-.75,14.89,14.89,0,0,1,5.41,1.34,6.22,6.22,0,0,1,2,1.22c0,.07-.8-.37-2.1-.88a17.06,17.06,0,0,0-5.29-1.16,17.37,17.37,0,0,0-5.38.58C105.45,404.72,104.65,405.08,104.61,405Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '112.10999298095703px 404.52266573905945px',
          }}
          id="el5d8bm7yt3te"
          className="animable"
        />
        <path
          d="M249.19,330.05l0,0c-13.45-17.84-27.93-16.37-35.31-16.58v-7.83c-5.45,0-12.9,4.91-16.75,8.42l-3.81,5.23h0a19.42,19.42,0,0,0-12.44-12.21,38.42,38.42,0,0,0-6.37-1.44v7c-18.08.51-27.75,5.45-39.83,19.43-.62.72-1.85,1.95-3.26,3.34h0l-35.74,42c-7.3,8.08-14,19.2-12.43,30h0c1.71,12.16,8.8,20.16,22.37,29.33l37.6,24.37-.18,4.19h89.73s60.85-44.89,62.34-61.52C296.27,390.64,275.31,362.79,249.19,330.05ZM144.73,425.36l-26.31-19.63,28.42-29.41Zm86.16,1.56-.71-14.53L234,374.22c7.5,8.6,21.38,25.67,21.38,28.22Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '189.0876922607422px 385.4700164794922px',
          }}
          id="elkhf6r7h3mk"
          className="animable"
        />
        <path
          d="M213.86,313.51a7.64,7.64,0,0,1-.68,1.19c-.48.74-1.17,1.81-2.08,3.1a70.81,70.81,0,0,1-7.87,9.48c-.85.86-1.71,1.67-2.55,2.44l-.42.39v-.57a12.71,12.71,0,0,0-3.68-8.76,5.45,5.45,0,0,0-2.29-1.62,1.43,1.43,0,0,0-1,.17,1,1,0,0,1,1-.35,5.2,5.2,0,0,1,2.49,1.56,12.75,12.75,0,0,1,2.64,3.58,12.88,12.88,0,0,1,1.32,5.41l-.42-.19c.82-.77,1.68-1.57,2.52-2.43a85.81,85.81,0,0,0,7.95-9.32l2.2-3A6.82,6.82,0,0,1,213.86,313.51Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '203.57500457763672px 321.8100280761719px',
          }}
          id="el4f0pdqy4i9z"
          className="animable"
        />
        <path
          d="M174.49,312.68a5.69,5.69,0,0,1,.78.93l2,2.63c1.67,2.24,3.93,5.36,6.41,8.82l1.62,2.26-.45.07a21.62,21.62,0,0,1,2-4.63,7.9,7.9,0,0,1,2.89-2.85,5.36,5.36,0,0,1,2.59-.72,2.12,2.12,0,0,1,1,.14s-.34,0-1,0a5.67,5.67,0,0,0-2.43.83,8,8,0,0,0-2.68,2.8,22.56,22.56,0,0,0-1.92,4.55l-.16.47-.29-.4-1.62-2.26c-2.48-3.46-4.7-6.61-6.29-8.9-.73-1.09-1.35-2-1.85-2.73A5.4,5.4,0,0,1,174.49,312.68Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '183.9099884033203px 320.3299865722656px',
          }}
          id="eltoa027zj1t"
          className="animable"
        />
        <g id="elwtn8lgvaa8">
          <g
            style={{
              opacity: '0.1',
              transformOrigin: '204.45001983642578px 325.0838918685913px',
            }}
            className="animable"
          >
            <path
              d="M193.3,319.33a15.4,15.4,0,0,1,3.91,12.27c-.19,1.46-.36,3.41,1,3.95.95.37,2-.28,2.77-.92a54.41,54.41,0,0,0,14.1-17.2,3.28,3.28,0,0,0,.52-1.75,1.2,1.2,0,0,0-1.17-1.17,1.76,1.76,0,0,0-1,.73c-4.16,4.8-8.76,9.79-12.92,14.58a10.62,10.62,0,0,0-2.31-7.39c-1.65-2-3.45-4.07-4.87-3.1"
              id="elowg0uthuhk"
              style={{
                transformOrigin: '204.45001983642578px 325.0838918685913px',
              }}
              className="animable"
            />
          </g>
        </g>
        <path
          d="M231.67,463.62a2.53,2.53,0,0,1-.31-.42c-.22-.32-.49-.74-.84-1.26l-3.07-4.76c-2.61-4.14-6.26-9.91-10.51-16.62l-.1-.17.14-.13,9.38-9.36,20.41-20.2c2.6-2.54,4.72-4.6,6.22-6.08l1.72-1.63a5.46,5.46,0,0,1,.62-.55,4.57,4.57,0,0,1-.55.62c-.41.43-1,1-1.64,1.71L247,411l-20.31,20.31c-3.3,3.29-6.48,6.44-9.39,9.33l0-.3c4.18,6.75,7.78,12.55,10.35,16.72,1.24,2,2.24,3.66,2.95,4.84.32.53.57,1,.77,1.3A2.31,2.31,0,0,1,231.67,463.62Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '236.08499908447266px 433.0299835205078px',
          }}
          id="eltd041ho8xy"
          className="animable"
        />
        <path
          d="M220.64,323.65l-.15.19-.46.54c-.43.46-1,1.18-1.72,2.12a21.22,21.22,0,0,0-3.83,9.13,26.23,26.23,0,0,0,2.23,14.43,34.07,34.07,0,0,0,4.4,7.53C223,360,225,362.41,227.05,365c8.07,10.17,15,19.64,20.1,26.44l6,8.07c.69.92,1.23,1.66,1.63,2.2l.41.58.13.2s-.07-.05-.17-.17l-.45-.55L253,399.58c-1.47-1.87-3.57-4.59-6.15-8-5.16-6.74-12.15-16.18-20.2-26.33-2-2.55-4-5-5.94-7.37a34.56,34.56,0,0,1-4.44-7.66,26.35,26.35,0,0,1-2.15-14.68A21.28,21.28,0,0,1,220,324.31l.5-.5C220.57,323.7,220.63,323.64,220.64,323.65Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '234.5911865234375px 363.0694770812988px',
          }}
          id="elid89nlbj3df"
          className="animable"
        />
        <path
          d="M254.37,336.56c0,.05-.55.24-1.49.74a14.85,14.85,0,0,0-3.55,2.73,29.41,29.41,0,0,0-4,5.34,81.78,81.78,0,0,1-4.47,7,17,17,0,0,1-13,6.92,15.88,15.88,0,0,1-4.55-.43,9.78,9.78,0,0,1-1.19-.35,2.59,2.59,0,0,1-.4-.17,21.8,21.8,0,0,0,6.12.58,17.22,17.22,0,0,0,6.39-1.71,17,17,0,0,0,6.18-5.16c1.77-2.3,3.11-4.76,4.47-6.9a28.16,28.16,0,0,1,4.15-5.35,13.94,13.94,0,0,1,3.72-2.66,9.26,9.26,0,0,1,1.16-.45A1.77,1.77,0,0,1,254.37,336.56Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '238.04498291015625px 347.93499851226807px',
          }}
          id="elmypi8prtks9"
          className="animable"
        />
        <path
          d="M230.52,424.49l-.24,0-.67-.16c-.3-.08-.67-.13-1.11-.2a14.34,14.34,0,0,0-1.52-.17,28.17,28.17,0,0,0-9.65,1.24,48.26,48.26,0,0,0-6.35,2.32c-2.22,1-4.52,2.22-7,3.39a45.73,45.73,0,0,1-8.08,3.06,24.16,24.16,0,0,1-4.54.72,19.89,19.89,0,0,1-4.73-.34,27.75,27.75,0,0,1-8.59-3.54c-2.58-1.54-4.89-3.29-7.1-4.91-4.37-3.28-8.55-6-12.52-7.18a20.16,20.16,0,0,0-5.47-.9,15.33,15.33,0,0,0-4.15.49,16.78,16.78,0,0,0-3.32,1.33l.19-.14.6-.36a11.85,11.85,0,0,1,2.48-1,15.31,15.31,0,0,1,4.21-.58,20.16,20.16,0,0,1,5.56.83c4.06,1.15,8.31,3.89,12.7,7.15,2.22,1.62,4.53,3.34,7.08,4.86a27.22,27.22,0,0,0,8.43,3.47,18.81,18.81,0,0,0,4.6.33,23.22,23.22,0,0,0,4.44-.69,45.78,45.78,0,0,0,8-3c2.48-1.16,4.79-2.38,7-3.35a47.12,47.12,0,0,1,6.42-2.28,27.33,27.33,0,0,1,9.76-1.09A13.09,13.09,0,0,1,230.52,424.49Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '188px 426.1362714767456px',
          }}
          id="ely70c8mqwtoi"
          className="animable"
        />
        <path
          d="M131.67,415.61s.05.12.08.35a7.37,7.37,0,0,1,.12,1,15.07,15.07,0,0,1-.16,3.71,12.29,12.29,0,0,1-2.08,5.12,15.84,15.84,0,0,1-5.13,4.39c-2,1.23-4.07,2.26-5.72,3.46a15.69,15.69,0,0,0-3.86,3.73,6.21,6.21,0,0,0-1.15,3.36c0,.86.13,1.33.07,1.34a1,1,0,0,1-.12-.33,5.19,5.19,0,0,1-.16-1,6.17,6.17,0,0,1,1-3.57,15.31,15.31,0,0,1,3.89-3.92c1.68-1.25,3.71-2.3,5.73-3.51a16,16,0,0,0,5-4.23,12.39,12.39,0,0,0,2.11-4.9,18.15,18.15,0,0,0,.32-3.64A9.57,9.57,0,0,1,131.67,415.61Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '122.73776626586914px 428.83998107910156px',
          }}
          id="el5mzqpjnyzfo"
          className="animable"
        />
        <path
          d="M282.58,374.22a22.67,22.67,0,0,0-5.93,1.86,17.68,17.68,0,0,0-5.33,4,16.38,16.38,0,0,0-2.26,3.24c-.66,1.21-1.11,2.58-1.76,3.93a9.68,9.68,0,0,1-2.63,3.52,11.79,11.79,0,0,1-3.58,2,17.51,17.51,0,0,1-6.8.84,40.3,40.3,0,0,1-4.58-.54,10.76,10.76,0,0,1-1.65-.35,9.85,9.85,0,0,1,1.68.15c1.08.11,2.63.32,4.56.37a17.72,17.72,0,0,0,6.63-.93,9.79,9.79,0,0,0,5.9-5.27c.63-1.32,1.09-2.7,1.78-3.95A16.33,16.33,0,0,1,271,379.8a17.55,17.55,0,0,1,5.53-4.06,16.61,16.61,0,0,1,4.4-1.38,12.35,12.35,0,0,1,1.25-.14A1.23,1.23,0,0,1,282.58,374.22Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '265.31998443603516px 383.9307498931885px',
          }}
          id="elw95b472o8w"
          className="animable"
        />
        <path
          d="M232.88,382.66l-.23.07-.68.15c-.6.13-1.49.29-2.65.47a60.25,60.25,0,0,1-9.87.7A45.74,45.74,0,0,1,205,381.6a48,48,0,0,1-7.86-3.69,57,57,0,0,0-8.3-4.05,19,19,0,0,0-4.52-1,18.13,18.13,0,0,0-4.49.22,29.25,29.25,0,0,0-8,2.9c-4.85,2.57-8.93,5.43-12.62,7.42A30.46,30.46,0,0,1,150,387a13,13,0,0,1-2.67.29l-.7,0a.87.87,0,0,1-.24,0l.24,0,.69-.08a15.19,15.19,0,0,0,2.64-.39,31.7,31.7,0,0,0,9.07-3.71c3.63-2,7.69-4.91,12.57-7.53a29.4,29.4,0,0,1,8.17-3,18.69,18.69,0,0,1,4.62-.24,19.32,19.32,0,0,1,4.65,1.05,56.08,56.08,0,0,1,8.37,4.1,50.11,50.11,0,0,0,7.78,3.68,46.14,46.14,0,0,0,14.29,2.53,64.87,64.87,0,0,0,9.83-.53c1.16-.15,2.05-.28,2.66-.38l.69-.09A.87.87,0,0,1,232.88,382.66Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '189.63500213623047px 379.7948570251465px',
          }}
          id="elseznxb80qv"
          className="animable"
        />
        <path
          d="M135.13,388.44a3.42,3.42,0,0,0-.06-1.54,4.43,4.43,0,0,0-3.14-2.57c-.87-.26-1.86-.41-2.92-.65a7.23,7.23,0,0,1-3.21-1.47,8.52,8.52,0,0,1-2.22-3.2,25.42,25.42,0,0,1-1.15-4,21.9,21.9,0,0,0-1.14-3.88,14.44,14.44,0,0,0-1.87-3.24,14.21,14.21,0,0,0-4.83-4.07,15.06,15.06,0,0,0-4-1.42c-1-.2-1.57-.24-1.57-.29a1.07,1.07,0,0,1,.42,0,9.64,9.64,0,0,1,1.18.11,13.7,13.7,0,0,1,4.19,1.29,14.22,14.22,0,0,1,5,4.11,14.53,14.53,0,0,1,2,3.33,22.25,22.25,0,0,1,1.18,4,25.17,25.17,0,0,0,1.11,3.89,8.15,8.15,0,0,0,2.06,3,6.81,6.81,0,0,0,3,1.42c1,.26,2,.43,2.93.72a4.59,4.59,0,0,1,3.23,2.86,2.44,2.44,0,0,1,0,1.21A1,1,0,0,1,135.13,388.44Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '122.20809268951416px 375.2645683288574px',
          }}
          id="el71rvwvqjezm"
          className="animable"
        />
        <path
          d="M214.11,337.15a13.38,13.38,0,0,0-2.94-1.19,9.13,9.13,0,0,0-3.68,0,19,19,0,0,0-4.67,1.57c-1.67.75-3.43,1.73-5.35,2.74a30.49,30.49,0,0,1-6.43,2.67,18.68,18.68,0,0,1-7.69.25,29.94,29.94,0,0,1-7.84-2.59c-5.11-2.49-9.36-5.83-13.46-8.43a36,36,0,0,0-11.65-5.33,18.92,18.92,0,0,0-8.59-.1,30.42,30.42,0,0,0-3,1,11.94,11.94,0,0,1,3-1.19,18.51,18.51,0,0,1,8.72-.06,35.76,35.76,0,0,1,11.83,5.28c4.14,2.59,8.39,5.92,13.42,8.37a29.79,29.79,0,0,0,7.7,2.56,18.4,18.4,0,0,0,7.49-.22,29.91,29.91,0,0,0,6.35-2.58c1.92-1,3.7-2,5.4-2.7a19.65,19.65,0,0,1,4.77-1.52,9.27,9.27,0,0,1,3.78.14,9.51,9.51,0,0,1,2.2.92A7,7,0,0,1,214.11,337.15Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '176.46001434326172px 334.7369165420532px',
          }}
          id="elt77xrwyp2il"
          className="animable"
        />
        <path
          d="M208.46,464.11l2.78,1.39,16,0,3.23-2.64L218.83,443.6c-1.43.63-7.71,1.61-9.74,2.32a16.29,16.29,0,0,1-5.45.92,29.65,29.65,0,0,1-6.17-.51l-.44-.14a2.21,2.21,0,0,0-.86-.18c-1.73-.15-3.1,1.66-2.13,3.09s5.7,3.34,11.74,3.17h.29c5.3,0,.44,4.44-2.71,7.08a4.18,4.18,0,0,0-1.52,3.79,1.78,1.78,0,0,0,.71,1.3C203.89,465.29,208.46,464.11,208.46,464.11Z"
          style={{
            fill: 'rgb(255, 190, 157)',
            transformOrigin: '212.0939769744873px 454.5500030517578px',
          }}
          id="elwotntfbvglg"
          className="animable"
        />
        <path
          d="M143.17,461.72a1.23,1.23,0,0,1,0-.28c0-.22,0-.49,0-.83,0-.77.06-1.84.11-3.19.12-2.8.28-6.79.49-11.71.41-9.92,1-23.56,1.61-38.63s1-28.76,1.28-38.65c.11-4.92.19-8.91.25-11.72,0-1.35.05-2.42.07-3.19,0-.34,0-.61,0-.82a1.11,1.11,0,0,1,0-.29.94.94,0,0,1,0,.29c0,.21,0,.49,0,.82,0,.77,0,1.84,0,3.19,0,2.77,0,6.77-.08,11.72-.14,9.9-.54,23.57-1.13,38.67s-1.24,28.75-1.76,38.63c-.28,4.91-.5,8.9-.66,11.7-.09,1.35-.16,2.42-.21,3.18l-.07.83A1.33,1.33,0,0,1,143.17,461.72Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '145.03062915802002px 407.0650177001953px',
          }}
          id="elywvh1brhkia"
          className="animable"
        />
        <path
          d="M186.7,463.62a1.49,1.49,0,0,1,0-.37c0-.27-.05-.63-.09-1.09l-.29-4.21c-.12-1.82-.27-4.06-.35-6.66s-.27-5.55-.29-8.82-.14-6.86-.09-10.71c0-1.92,0-3.91,0-6s.09-4.16.14-6.32c.25-8.65.7-18.15,1.4-28.11,1.4-19.93,3.18-37.92,4.32-50.95.56-6.5,1-11.76,1.34-15.44.15-1.79.28-3.2.36-4.19.05-.46.08-.82.11-1.09s.05-.37.05-.37a1.7,1.7,0,0,1,0,.37l-.05,1.1c-.07,1-.16,2.4-.27,4.2-.23,3.65-.64,8.93-1.17,15.45-1.05,13-2.77,31-4.17,50.95-.7,10-1.16,19.45-1.44,28.09,0,2.16-.11,4.27-.16,6.32s0,4-.07,6c-.06,3.84,0,7.42,0,10.69s.15,6.23.21,8.82.17,4.84.26,6.66.15,3.22.2,4.21l0,1.1A1.75,1.75,0,0,1,186.7,463.62Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '189.44901537895203px 391.4550018310547px',
          }}
          id="el5gjs2f503aw"
          className="animable"
        />
        <path
          d="M194.06,365.1c-.05-.05.51-.28,1.13.25a1.48,1.48,0,0,1,.49,1.27,1.49,1.49,0,0,1-2.73.45,1.47,1.47,0,0,1,.05-1.35c.41-.71,1-.67,1-.6s-.43.17-.66.76a1.18,1.18,0,0,0,0,1,1.06,1.06,0,0,0,1.84-.31,1.2,1.2,0,0,0-.28-.93C194.52,365.13,194.06,365.19,194.06,365.1Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '194.2493200302124px 366.3982148170471px',
          }}
          id="elctdv6ud55ar"
          className="animable"
        />
        <path
          d="M191.25,410c-.05-.05.52-.29,1.14.25a1.47,1.47,0,0,1,.48,1.26,1.4,1.4,0,0,1-1.21,1.15,1.43,1.43,0,0,1-1.52-.69,1.51,1.51,0,0,1,.06-1.36c.41-.71,1-.66,1-.6s-.43.18-.66.76a1.14,1.14,0,0,0,0,1,1,1,0,0,0,1.83-.31,1.14,1.14,0,0,0-.28-.92C191.72,410,191.25,410.07,191.25,410Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '191.44291985034943px 411.2957729101181px',
          }}
          id="els55gux4fyxh"
          className="animable"
        />
        <path
          d="M263,440.85a6.62,6.62,0,0,1-1.34-.17,18.31,18.31,0,0,1-3.52-1.13,19.68,19.68,0,0,1-9-8.05,31.11,31.11,0,0,1-2.49-6.23,18.5,18.5,0,0,0-2.21-4.9,9.13,9.13,0,0,0-2.54-2.54c-.73-.45-1.19-.6-1.17-.65a1.12,1.12,0,0,1,.34.08,5.44,5.44,0,0,1,.93.4,8.4,8.4,0,0,1,2.74,2.5,18.18,18.18,0,0,1,2.37,5,32,32,0,0,0,2.48,6.12,20.08,20.08,0,0,0,8.71,8A31.8,31.8,0,0,0,263,440.85Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '251.86470890045166px 429.01499938964844px',
          }}
          id="el4x41yb8rw2p"
          className="animable"
        />
      </g>
      <g
        id="freepik--character-2--inject-43"
        style={{ transformOrigin: '255.4600067138672px 343.2789306640625px' }}
        className="animable"
      >
        <path
          d="M365.44,465.47l-17-49.34,7.86-47.34c2.29-12.77,3.57-24,.14-30.43-9.17-17.13-20.24-18.67-35.36-22.6-3.12-.81-26.85-1.61-29.46-1-20.59,2.31-33.77,13.23-41,31l-7.84,31.6-10.77,33a14.13,14.13,0,0,1-9.49,7.73L181,432.28l.35,8.13-.35,11L236.3,441c11.08-2.08,22.35-6.17,25.53-16.86l5.95-17.62c2.91,7.46,6.08,14.3,6.08,14.3l-4,44.43Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '273.2200012207031px 390.0074920654297px',
          }}
          id="elsxy8xvk4iqe"
          className="animable"
        />
        <path
          d="M351.2,377.81l-15.8,52.83a25.5,25.5,0,0,1-17,17.08l-65.76,17.52-8.72-22.7,59.44-22.1,14.59-52.9s3.37-29.58,30.12-28.06"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '297.5600128173828px 402.33166122436523px',
          }}
          id="elcsklabn1jic"
          className="animable"
        />
        <path
          d="M348.06,339.48h-.8c-.53,0-1.31-.06-2.34,0a26.13,26.13,0,0,0-8.79,1.79,23.63,23.63,0,0,0-5.67,3.18,27.45,27.45,0,0,0-5.41,5.54,40.22,40.22,0,0,0-6.93,17.53h0c-4,14.72-9,32.74-14.53,52.93l0,.12-.11,0L244,442.78l.15-.33,1.55,4c2.45,6.4,4.87,12.7,7.16,18.67l-.31-.16,56.5-15,6.37-1.7c1-.28,2.09-.54,3.11-.84a26.6,26.6,0,0,0,2.94-1.12A25.14,25.14,0,0,0,333.9,434a35.35,35.35,0,0,0,1.86-5.22q1.58-5.24,3-10c3.85-12.74,6.94-23,9.07-30l2.47-8.1.65-2.09c.15-.47.24-.71.24-.71s-.06.25-.19.72-.34,1.19-.61,2.11c-.55,1.87-1.35,4.6-2.38,8.13l-8.92,30.07q-1.41,4.79-3,10a35.37,35.37,0,0,1-1.86,5.28,25.55,25.55,0,0,1-3,5,25.82,25.82,0,0,1-9.58,7.58,28.9,28.9,0,0,1-3,1.15c-1,.3-2.07.56-3.12.85l-6.37,1.7-56.49,15.08-.22.06-.08-.21c-2.29-6-4.72-12.28-7.17-18.67l-1.55-4-.09-.24.24-.09,59.45-22.08-.15.16c5.59-20.17,10.58-38.19,14.65-52.89v0a40.2,40.2,0,0,1,7.06-17.65,27.15,27.15,0,0,1,5.49-5.57,23.77,23.77,0,0,1,5.74-3.17,25.33,25.33,0,0,1,8.86-1.71,21.08,21.08,0,0,1,2.34,0Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '297.37498474121094px 402.5316581726074px',
          }}
          id="elkqzlossrpfn"
          className="animable"
        />
        <path
          d="M306.63,408.57a2.77,2.77,0,0,1-.79.06,9.77,9.77,0,0,1-2.13-.25,13.9,13.9,0,0,1-6.24-3.29,15.22,15.22,0,0,1-4.06-5.77,8,8,0,0,1-.39-1.17,5.77,5.77,0,0,1-.2-.9c-.08-.5-.11-.78-.07-.78s.27,1.08,1,2.7a16.54,16.54,0,0,0,4.06,5.53,14.9,14.9,0,0,0,6,3.32C305.51,408.48,306.63,408.46,306.63,408.57Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '299.68116092681885px 402.5531873703003px',
          }}
          id="elxyggpitywjt"
          className="animable"
        />
        <path
          d="M267.58,368.39a8.9,8.9,0,0,1-.55,1.55c-.39,1-1,2.41-1.63,4.19-1.3,3.53-3.13,8.54-3.32,14.3a23.81,23.81,0,0,0,1.09,8,28.64,28.64,0,0,0,2.71,6,40.64,40.64,0,0,0,2.49,3.71,12.51,12.51,0,0,1,1,1.34s-.12-.09-.32-.3-.47-.5-.81-.91a30.56,30.56,0,0,1-2.66-3.65,28.46,28.46,0,0,1-2.85-6.07,24,24,0,0,1-1.15-8.13A43.05,43.05,0,0,1,265.05,374c.71-1.76,1.35-3.16,1.79-4.13A10.56,10.56,0,0,1,267.58,368.39Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '265.4690628051758px 387.9350128173828px',
          }}
          id="el93dmjmalrtv"
          className="animable"
        />
        <path
          d="M309.14,427.49a19.63,19.63,0,0,0-2.42-4.1,19.36,19.36,0,0,0-3.69-3,2.91,2.91,0,0,1,1.36.47,9.55,9.55,0,0,1,4.48,5.2A3,3,0,0,1,309.14,427.49Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '306.0875644683838px 423.94000244140625px',
          }}
          id="elmi7fjduyj37"
          className="animable"
        />
        <path
          d="M245.13,445.7s-18.81,1.68-18.55,13.9L250,458.41Z"
          style={{
            fill: 'rgb(183, 136, 118)',
            transformOrigin: '238.28866577148438px 452.65000915527344px',
          }}
          id="elxhgxoja97vk"
          className="animable"
        />
        <path
          d="M275.45,240.93q-2.58,12.48-4.92,25c-2,10.58-3.8,21.64-.81,32,1.64,5.68,4.66,10.84,7.65,15.94,1.68,2.86,3.52,5.88,6.5,7.36,4.05,2,9.17.42,12.4-2.75s4.86-7.59,6-12c2.17-8.54,2.65-17.41,3-26.22s.53-17.95-2-26.49-8.07-16.62-16.32-20"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '286.80266189575195px 277.94366455078125px',
          }}
          id="elyjhgwra9d2h"
          className="animable"
        />
        <path
          d="M276.81,234.25A14.58,14.58,0,0,1,285,231.2c2.4-4.86,8.09-7.09,13.41-8.12,7.84-1.53,7-1.74,14.29,1.48s17.67,12.32,19,20.2a71.91,71.91,0,0,0,6.57,19.88c2,4.15,5.9,7,8.21,11a16.4,16.4,0,0,1,.95,14.4c-1.88,4.51-5.87,8.49-5.49,13.35.21,2.83.11,4.85,1.23,7.46,3.79,8.84,2,20.62-6.14,25.72s-19.92,3.32-26.21-4c-5.46-6.32-6.51-15.34-6-23.68s2.43-16.63,1.89-25"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '312.7348213195801px 280.7419204711914px',
          }}
          id="elhy9ai21r4ir"
          className="animable"
        />
        <path
          d="M286.15,465.24l-.12-2.88-42.4-4.47-18.58-53.41-79.57-1.8,24.07,62.56Q228.56,465.69,286.15,465.24Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '215.81500244140625px 434.0724983215332px',
          }}
          id="elrhpcnkk1y4q"
          className="animable"
        />
        <path
          d="M189.63,434.82a4.16,4.16,0,1,0,1.53-5.68A4.16,4.16,0,0,0,189.63,434.82Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '193.23566436767578px 432.7451820373535px',
          }}
          id="elhuy9nsrjfn"
          className="animable"
        />
        <path
          d="M305.46,336.42c9.54,0,18.12-8.13,17.84-20.21l1.72-69h0a5.76,5.76,0,0,0-5.16-5.85l-28.43-3a17.32,17.32,0,0,0-19.1,16.14c-.68,10.92-1.09,24.29.2,32.44,2.6,16.39,15.17,18.48,15.17,18.48l-.31,11.45c-.48,12.2,8.65,19.54,18.07,19.54Z"
          style={{
            fill: 'rgb(183, 136, 118)',
            transformOrigin: '298.3552360534668px 287.3423538208008px',
          }}
          id="el9pyq6zq2hy8"
          className="animable"
        />
        <path
          d="M278.69,263.4a2.1,2.1,0,0,0,2,2.12,2,2,0,0,0,2.16-1.89,2.09,2.09,0,0,0-2-2.12A2,2,0,0,0,278.69,263.4Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '280.7700674533844px 263.5149812698364px',
          }}
          id="eljtv5q3pr3a"
          className="animable"
        />
        <path
          d="M275.23,261.46c.26.27,1.86-.9,4.12-.9s3.92,1.14,4.16.86c.12-.12-.14-.61-.86-1.14a5.81,5.81,0,0,0-3.34-1,5.54,5.54,0,0,0-3.27,1.06C275.34,260.84,275.11,261.34,275.23,261.46Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '279.3689365386963px 260.38993299007416px',
          }}
          id="elhnvx3p8n7x"
          className="animable"
        />
        <path
          d="M300.53,263.82a2.09,2.09,0,0,0,2,2.12,2,2,0,0,0,2.17-1.89,2.1,2.1,0,0,0-2-2.12A2,2,0,0,0,300.53,263.82Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '302.61494636535645px 263.9349935054779px',
          }}
          id="el68j1q0lje32"
          className="animable"
        />
        <path
          d="M297.47,261.88c.26.28,1.85-.9,4.11-.9s3.92,1.14,4.17.86c.12-.12-.14-.61-.87-1.14a5.82,5.82,0,0,0-3.33-1,5.57,5.57,0,0,0-3.28,1.06C297.58,261.26,297.34,261.76,297.47,261.88Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '301.6071124076843px 260.8112778663635px',
          }}
          id="elom7bftlia7c"
          className="animable"
        />
        <path
          d="M289.26,278.66a15,15,0,0,0-3.67-.66c-.58-.06-1.13-.18-1.23-.57a3,3,0,0,1,.39-1.72c.54-1.39,1.11-2.86,1.71-4.39,2.37-6.27,4.09-11.42,3.83-11.51s-2.38,4.91-4.75,11.17c-.57,1.55-1.12,3-1.64,4.43a3.4,3.4,0,0,0-.3,2.26,1.47,1.47,0,0,0,.95.85,3.74,3.74,0,0,0,1,.13A14.4,14.4,0,0,0,289.26,278.66Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '286.9206540584564px 269.29190731048584px',
          }}
          id="eldg9zpnnt9rf"
          className="animable"
        />
        <path
          d="M287.7,305.43a41.7,41.7,0,0,0,21.95-5.86s-5.33,11.26-21.73,9.73Z"
          style={{
            fill: 'rgb(170, 101, 80)',
            transformOrigin: '298.6750183105469px 304.5064654350281px',
          }}
          id="ely9jakrcx61"
          className="animable"
        />
        <path
          d="M290.22,284.11a4,4,0,0,1,3.65-1.51,3.74,3.74,0,0,1,2.57,1.37,2.36,2.36,0,0,1,.18,2.7,2.73,2.73,0,0,1-3,.75,8.7,8.7,0,0,1-2.89-1.72,2.54,2.54,0,0,1-.64-.67.75.75,0,0,1,0-.85"
          style={{
            fill: 'rgb(170, 101, 80)',
            transformOrigin: '293.4592773914337px 285.0807206630707px',
          }}
          id="elp4wd73kfhc"
          className="animable"
        />
        <path
          d="M295.92,280.22c-.37,0-.38,2.44-2.48,4.18s-4.71,1.47-4.73,1.82c0,.15.58.47,1.69.5a6.13,6.13,0,0,0,4-1.37,5.32,5.32,0,0,0,1.91-3.51C296.36,280.82,296.08,280.21,295.92,280.22Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '292.5129404067993px 283.4706904888153px',
          }}
          id="elles6hs8a6v9"
          className="animable"
        />
        <path
          d="M296.45,257.92c.22.62,2.48.33,5.14.65s4.8,1,5.15.49c.16-.27-.22-.84-1.08-1.44a8.6,8.6,0,0,0-3.82-1.34,8.72,8.72,0,0,0-4,.47C296.85,257.15,296.36,257.63,296.45,257.92Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '301.6076235771179px 257.73253870010376px',
          }}
          id="elt8n646ifjqg"
          className="animable"
        />
        <path
          d="M276.06,254.91c.4.52,2,0,3.84,0s3.46.34,3.82-.19c.16-.26-.09-.78-.78-1.26a5.51,5.51,0,0,0-6.17.19C276.11,254.13,275.89,254.66,276.06,254.91Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '279.8857831954956px 253.87418794631958px',
          }}
          id="el48dzdgk3o0s"
          className="animable"
        />
        <path
          d="M272.67,251.78c6.17-3.58,12.18-6.89,16-12.89,2.13,6,6.29,9,11.81,12.19s11.69,5.06,17.8,6.89c-3.09,3-3.5,7.85-2.79,12.1s2.34,8.34,2.61,12.64c.35,5.74-1.75,11.37-1.88,17.12-.18,7.89,3.3,15.34,6.71,22.45l14.81-8.63-2.13-38.45.18-27.21-23.09-21.46-29.24,3.2Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '305.2049865722656px 274.405029296875px',
          }}
          id="el950izfkfiy"
          className="animable"
        />
        <path
          d="M269.38,332.63c7.51,7.59,6.71,21.12,15,27.91,5.06,4.16,12.45,4.55,18.66,2.45s11.43-6.35,16.22-10.83,9.32-9.29,14.77-12.92c5.29-3.53,14.35-5.7,15.63-11.94.94-4.56-3.86-10.05-4.76-14.62-1.43-7.26,6.42-12.87,7.73-20.15,2.62-14.55-5.06-31.63-13.06-44S327.05,222.15,306.77,221c-18.15-.81-30.51,7.9-36.55,20.5-3,6.31-3.73,13.45-4.32,20.43-1.37,16.3-2.13,33.58,5.4,48.1,1.56,3,3.42,6.82,1.32,9.48-1.92,2.43-6.27,2.33-7.49,5.18S267.12,330.34,269.38,332.63ZM292,236c2.43-.1,9.64,0,17.68,10.71,4.81,6.41,4.8,16.79,4.7,25.84-.09,6.73,0,23.76,0,23.76s1.06,21.51-6.25,23.41c-9,2.34-16.83.73-23.54-5.66s-10.55-15.36-12.08-24.5-2.39-18.46-1.19-27.65A38.72,38.72,0,0,1,276.78,246,22.25,22.25,0,0,1,292,236Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '309.00719833374023px 292.59156036376953px',
          }}
          id="elilvyahqi6l"
          className="animable"
        />
        <g id="elce0gmkow1gm">
          <g
            style={{
              opacity: '0.30000000000000004',
              transformOrigin: '323.05999755859375px 326.5632743835449px',
            }}
            className="animable"
          >
            <path
              d="M348.06,320.27c-6,3.26-10.15,8.11-15,12.89s-10.34,9.41-17,11.13-14.67-.33-18-6.32c18.77,3.2,40.56-11.79,47-29.72A10.44,10.44,0,0,0,345,313,63.55,63.55,0,0,0,348.06,320.27Z"
              id="elbkc1uaikr"
              style={{
                transformOrigin: '323.05999755859375px 326.5632743835449px',
              }}
              className="animable"
            />
          </g>
        </g>
        <g id="ell0wty5n628q">
          <g
            style={{
              opacity: '0.30000000000000004',
              transformOrigin: '279.4081435203552px 324.0610303878784px',
            }}
            className="animable"
          >
            <path
              d="M273.43,315.32a18.45,18.45,0,0,0,9.07,11.46,12,12,0,0,1,2.86,1.69,2.78,2.78,0,0,1,.87,3,2.7,2.7,0,0,1-3.22,1.18,8,8,0,0,1-3-2.12c-3.27-3.16-6.64-6.36-7.56-10.8a5.27,5.27,0,0,0,1.08-2.23A10.07,10.07,0,0,0,273.43,315.32Z"
              id="elfge9dhb2et"
              style={{
                transformOrigin: '279.4081435203552px 324.0610303878784px',
              }}
              className="animable"
            />
          </g>
        </g>
        <path
          d="M343.57,311.8a2.54,2.54,0,0,1-.28.58c-.21.37-.48.94-.91,1.62a55.25,55.25,0,0,1-3.88,5.62,60.49,60.49,0,0,1-6.85,7.47,42,42,0,0,1-10.2,7.07,47.48,47.48,0,0,1-6.06,2.17,46.35,46.35,0,0,1-5.86,1.3,40.94,40.94,0,0,1-10.13.38,35.08,35.08,0,0,1-6.71-1.28c-.78-.21-1.36-.45-1.76-.59a2.53,2.53,0,0,1-.6-.25s.86.24,2.42.64a37.48,37.48,0,0,0,6.69,1.11,42.06,42.06,0,0,0,10-.48,46.76,46.76,0,0,0,5.78-1.32,48,48,0,0,0,6-2.15,42.65,42.65,0,0,0,10.09-7,63.26,63.26,0,0,0,6.88-7.34,64.51,64.51,0,0,0,4-5.5c.45-.66.75-1.21,1-1.56A4.14,4.14,0,0,1,343.57,311.8Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '316.9499969482422px 324.98173236846924px',
          }}
          id="elle7vr8z9zxn"
          className="animable"
        />
        <path
          d="M297.54,330.35a4.67,4.67,0,0,1-1.19.31,18.72,18.72,0,0,1-3.34.3,20.52,20.52,0,0,1-18.2-10.91,18.41,18.41,0,0,1-1.31-3.1,4.73,4.73,0,0,1-.28-1.2,43.19,43.19,0,0,0,1.92,4.12A21,21,0,0,0,293,330.59C295.81,330.67,297.53,330.24,297.54,330.35Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '285.37998962402344px 323.3550238609314px',
          }}
          id="elczcn8hvp0ka"
          className="animable"
        />
        <path
          d="M293.65,355.13a2.14,2.14,0,0,1,.58-.15c.38-.09,1-.17,1.68-.35a52.9,52.9,0,0,0,6.07-1.69,69.24,69.24,0,0,0,18.27-9.77A151.46,151.46,0,0,0,336,329.56l4.54-4.4c.5-.49.92-.88,1.24-1.19a2.84,2.84,0,0,1,.46-.39,3,3,0,0,1-.38.46l-1.18,1.26c-1,1.08-2.53,2.63-4.42,4.52a136.52,136.52,0,0,1-15.7,13.78,66.31,66.31,0,0,1-18.46,9.69,45.26,45.26,0,0,1-6.15,1.54c-.73.15-1.32.2-1.71.25A2.39,2.39,0,0,1,293.65,355.13Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '317.9449768066406px 339.3559322357178px',
          }}
          id="el8j1k20xaa0c"
          className="animable"
        />
      </g>
      <g
        id="freepik--character-3--inject-43"
        style={{ transformOrigin: '553.4071807861328px 345.49903869628906px' }}
        className="animable"
      >
        <path
          d="M645.81,376.11l-35.28-41.6-.08.08c-1.39-1.37-2.61-2.59-3.23-3.3-12.22-14.16-21.93-19-40.64-19.26h0l-36.36.78c-6.76.56-22.1-2.33-36.29,16.48v0c-25.85,32.39-46.58,59.94-45.41,72.94,1.47,16.45,64.21,63.35,64.21,63.35l86.24-.07-.18-6.57L636,434.79c13.42-9.07,20.43-17,22.13-29C659.62,395.11,653,384.11,645.81,376.11Zm-158,24.76c0-2.53,13.6-18.48,21-27l3.85,36.83L512,425.09Zm109.41,22.67L595.17,375h0l28.12,29.09Z"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '553.4071884155273px 388.8049774169922px',
          }}
          id="eljchr713p0c"
          className="animable"
        />
        <g id="ell89ig9xj0i">
          <rect
            x="484.29"
            y="409.47"
            width="77.95"
            height="53.35"
            rx="3.42"
            style={{
              fill: 'rgb(224, 224, 224)',
              transformOrigin: '523.265px 436.14500000000004px',
              transform: 'rotate(-26.3deg)',
            }}
            className="animable"
          />
        </g>
        <path
          d="M523,432.19a3.95,3.95,0,1,1-1.31,5.43A3.95,3.95,0,0,1,523,432.19Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            transformOrigin: '525.0604259967804px 435.56007266044617px',
          }}
          id="el9cvg3mhgosu"
          className="animable"
        />
        <path
          d="M594.63,340.46a1.34,1.34,0,0,1,0,.32c0,.24,0,.54,0,.93,0,.85,0,2.05,0,3.57,0,3.14.06,7.62.1,13.15.06,11.1.49,26.42,1.35,43.34s1.74,32.23,2.21,43.32c.24,5.54.4,10,.49,13.14,0,1.52.06,2.72.08,3.57,0,.39,0,.69,0,.93a1.57,1.57,0,0,1,0,.32,1.64,1.64,0,0,1,0-.32c0-.24,0-.54-.06-.93,0-.85-.11-2-.18-3.57-.16-3.13-.39-7.61-.66-13.12-.61-11.12-1.44-26.42-2.36-43.32s-1.24-32.26-1.2-43.36c0-5.52,0-10,.07-13.15,0-1.52,0-2.72.05-3.57,0-.39,0-.69,0-.93A2,2,0,0,1,594.63,340.46Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '596.6324393749237px 401.75498962402344px',
          }}
          id="el5180t199tap"
          className="animable"
        />
        <path
          d="M504.84,318.71c4.6-3.35,9.95-2.34,14.56,1s7.17,9,7.63,14.67-1,11.35-3.15,16.61c-3.47,8.43-8.6,15.25-16.27,23.93l-19.76,25.95L526,438.11l-15.81,24.94-31.94-25.71c-10.91-9.21-20.19-18.63-27-28.37"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '489.18246841430664px 389.8477096557617px',
          }}
          id="elkbwl34dckui"
          className="animable"
        />
        <path
          d="M451.24,409l.23.3.67.9c.59.79,1.47,2,2.66,3.46a139,139,0,0,0,11,12.19c2.5,2.49,5.35,5.16,8.53,8s6.76,5.65,10.56,8.7l25.4,20.38-.35.06c4.91-7.75,10.24-16.17,15.79-24.95l0,.32-19.68-19.2-18.46-18-.16-.15.13-.18c7-9.15,13.62-17.85,19.78-25.94h0a129.29,129.29,0,0,0,10.45-13.12,59.69,59.69,0,0,0,6.87-13.49A34.16,34.16,0,0,0,526.9,335a21.86,21.86,0,0,0-3.37-10.74,17.38,17.38,0,0,0-6.78-6.08,12.59,12.59,0,0,0-6.59-1.46,10.16,10.16,0,0,0-4.05,1.2c-.86.46-1.26.77-1.27.75l.3-.23a7.48,7.48,0,0,1,.93-.59,10.16,10.16,0,0,1,4.08-1.28,12.64,12.64,0,0,1,6.7,1.42,17.38,17.38,0,0,1,6.91,6.11A22.12,22.12,0,0,1,527.24,335a34.59,34.59,0,0,1-2.12,13.27,59.88,59.88,0,0,1-6.88,13.61,130.11,130.11,0,0,1-10.45,13.18h0c-6.16,8.09-12.79,16.8-19.75,26l0-.34,18.47,18,19.67,19.21.15.15-.11.17c-5.56,8.78-10.9,17.19-15.82,24.93l-.14.23-.21-.17-25.35-20.45c-3.79-3.06-7.39-5.9-10.54-8.74s-6-5.51-8.51-8a134.75,134.75,0,0,1-10.95-12.31c-1.17-1.5-2-2.7-2.6-3.51-.28-.39-.49-.7-.64-.92S451.24,409,451.24,409Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '489.2518730163574px 389.9764404296875px',
          }}
          id="elhk0xxmrsqwf"
          className="animable"
        />
        <path
          d="M637,403.4a14.82,14.82,0,0,1-2-.62,13.83,13.83,0,0,0-9.73.51,16,16,0,0,1-1.93.83,5.88,5.88,0,0,1,1.77-1.17,12.36,12.36,0,0,1,10-.52A6.07,6.07,0,0,1,637,403.4Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '630.1700134277344px 402.86765110492706px',
          }}
          id="elmvxcjehatpa"
          className="animable"
        />
        <path
          d="M533.81,461.88l-6.94,3.45a9.78,9.78,0,0,1-10.54-1.18L512,460.62l12-18.87c1.41.61,7.21,1.43,9.21,2.14a16,16,0,0,0,5.39.9,29.83,29.83,0,0,0,6.11-.5c.13-.05.31-.09.43-.14A2,2,0,0,1,546,444c1.71-.16,3.07,1.64,2.11,3s-5.64,3.3-11.62,3.13l-.28,0c-5.25,0-.43,4.39,2.68,7a4.12,4.12,0,0,1,1.5,3.75,1.74,1.74,0,0,1-.7,1.29C538.33,463.05,533.81,461.88,533.81,461.88Z"
          style={{
            fill: 'rgb(163, 104, 83)',
            transformOrigin: '530.2140941619873px 454.0518217086792px',
          }}
          id="eli9clh638wnf"
          className="animable"
        />
        <path
          d="M549.87,329.4c-9.2,0-17.47-7.84-17.39-19.52l-1.66-66.51.19,0a5.56,5.56,0,0,1,5-5.64l27.42-2.9a16.69,16.69,0,0,1,18.41,15.56c.66,10.53,1.06,23.42-.19,31.28C579.11,297.5,567,299.52,567,299.52l.29,11c.47,11.76-8.34,18.84-17.42,18.84Z"
          style={{
            fill: 'rgb(163, 104, 83)',
            transformOrigin: '556.6416778564453px 282.06884765625px',
          }}
          id="elde66lxed7nj"
          className="animable"
        />
        <path
          d="M575.68,259a2,2,0,0,1-1.95,2,1.93,1.93,0,0,1-2.09-1.83,2,2,0,0,1,2-2A2,2,0,0,1,575.68,259Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '573.6599731445312px 259.0881333351135px',
          }}
          id="elwqvwn9vftom"
          className="animable"
        />
        <path
          d="M579,257.12c-.25.27-1.78-.87-4-.86s-3.77,1.09-4,.83.14-.6.84-1.11a5.61,5.61,0,0,1,3.21-1,5.38,5.38,0,0,1,3.16,1C578.91,256.53,579.14,257,579,257.12Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '574.9854397773743px 256.0706218481064px',
          }}
          id="elvs7bpdupzme"
          className="animable"
        />
        <path
          d="M554.63,259.4a2,2,0,0,1-2,2.05,2,2,0,0,1-2.09-1.83,2,2,0,0,1,2-2.05A2,2,0,0,1,554.63,259.4Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '552.584974527359px 259.5099803209305px',
          }}
          id="elai6wi91one4"
          className="animable"
        />
        <path
          d="M557.57,257.53c-.25.27-1.79-.87-4-.87s-3.78,1.1-4,.83c-.12-.11.14-.59.84-1.1a5.53,5.53,0,0,1,3.21-1,5.38,5.38,0,0,1,3.16,1C557.47,256.93,557.7,257.41,557.57,257.53Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '553.5732221603394px 256.48060286045074px',
          }}
          id="elv159p2pz07j"
          className="animable"
        />
        <path
          d="M565.49,273.71a13.94,13.94,0,0,1,3.54-.64c.56-.06,1.09-.17,1.18-.55a2.84,2.84,0,0,0-.37-1.65c-.53-1.35-1.07-2.76-1.65-4.24-2.29-6-3.94-11-3.7-11.1s2.3,4.73,4.58,10.77c.56,1.49,1.08,2.91,1.58,4.27a3.2,3.2,0,0,1,.29,2.19,1.42,1.42,0,0,1-.91.81,3.91,3.91,0,0,1-.95.13A14.55,14.55,0,0,1,565.49,273.71Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '567.742148399353px 264.6723384857178px',
          }}
          id="el3kk2c4vgxpg"
          className="animable"
        />
        <path
          d="M567,299.52a40.26,40.26,0,0,1-21.17-5.65s5.48,11.89,21.29,10.41Z"
          style={{
            fill: 'rgb(143, 80, 57)',
            transformOrigin: '556.4750061035156px 299.1387634277344px',
          }}
          id="eln2465kqtgpg"
          className="animable"
        />
        <path
          d="M558.55,253.71c-.21.6-2.39.31-4.95.62s-4.63,1-5,.48c-.16-.26.2-.82,1-1.39a8.65,8.65,0,0,1,7.56-.83C558.17,253,558.65,253.43,558.55,253.71Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '553.5628409385681px 253.5380072593689px',
          }}
          id="elozw5gghnra"
          className="animable"
        />
        <path
          d="M578.21,250.81c-.38.5-1.89,0-3.69,0s-3.34.33-3.69-.19c-.16-.25.09-.74.75-1.21a5.08,5.08,0,0,1,3-.81,5,5,0,0,1,2.94,1C578.17,250.06,578.38,250.57,578.21,250.81Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '574.5248007774353px 249.81327998638153px',
          }}
          id="elso5phdp68y"
          className="animable"
        />
        <path
          d="M531,258.48c2.69-.48,4.84.35,5.6,3,1.13,3.95.36,5.9.55,8.62l4-1.2c-1-9.11,1.27-15.85.28-25,5.56,1.8,13.2-1.64,15.57-7.4a15.48,15.48,0,0,0,16.5,1.16,6.36,6.36,0,0,0,6.79,3.18c3-.85,6.18-5.12,7.05-8.15,1.56-5.45.8-13.27-3.62-16.82s-13.28-2.7-16.72,1.81c-1.36,1.78-1.52,5.07-3.71,5.52-1.95.4-3.72-1-5.5-1.92-5.55-2.75-13.22.9-14.59,6.94-4.64-2.77-10.26-4.58-15.45-3.09s-9.33,7.25-7.56,12.35c.73,2.14,2.38,4,2.56,6.23.35,4.35-4.87,8.29-3.2,12.32.93,2.26,3.66,3.26,4.89,5.37,1.38,2.36.52,5.34.64,8.07.18,4.56,2.52,11.31,6.89,12.61"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '553.6506996154785px 247.87529754638672px',
          }}
          id="elf1w2xzzkoo7"
          className="animable"
        />
        <path
          d="M531.41,258.43a3.77,3.77,0,0,0-3,2.41,8.28,8.28,0,0,0-.81,3.89,8.69,8.69,0,0,0,1.9,5.8,5,5,0,0,0,5.64,1.43"
          style={{
            fill: 'rgb(163, 104, 83)',
            transformOrigin: '531.3661584854126px 265.3667426109314px',
          }}
          id="elpcjyvpjreg8"
          className="animable"
        />
        <path
          d="M534.14,268.53c0,.05-.59.27-1.52-.06a3.25,3.25,0,0,1-1.37-1,3.72,3.72,0,0,1-.73-2,3.77,3.77,0,0,1,.41-2,3.63,3.63,0,0,1,1.12-1.27c.82-.54,1.46-.51,1.45-.45a9,9,0,0,0-1.22.75,3.49,3.49,0,0,0-1.24,3,3.14,3.14,0,0,0,1.73,2.65A9.22,9.22,0,0,0,534.14,268.53Z"
          style={{
            fill: 'rgb(143, 80, 57)',
            transformOrigin: '532.3251222372055px 265.18332600593567px',
          }}
          id="eliidyl3w83l9"
          className="animable"
        />
        <path
          d="M558.55,281.43c2,1.37,5.78.65,7.2-1.38a38.54,38.54,0,0,1-8.36-6.15S554.55,278.62,558.55,281.43Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '561.0810875892639px 278.01692628860474px',
          }}
          id="els2hfeqcmcrt"
          className="animable"
        />
        <path
          d="M565,286.05a8.9,8.9,0,0,0-2.54-.6,9.5,9.5,0,0,0-2.54.57s.15-.31.6-.58a3.9,3.9,0,0,1,3.89,0C564.86,285.73,565.06,286,565,286.05Z"
          style={{
            fill: 'rgb(170, 101, 80)',
            transformOrigin: '562.4652214050293px 285.4851875305176px',
          }}
          id="el03c4m5dx1wt5"
          className="animable"
        />
      </g>
      <g
        id="freepik--character-4--inject-43"
        style={{ transformOrigin: '442.3443908691406px 338.6166305541992px' }}
        className="animable"
      >
        <path
          d="M540.67,350.08a184.92,184.92,0,0,0,11.49-19.4c4.13-7.88,3.43-8.28,2.44-8.63-2.66-.95-7.79,13.57-8.47,9.77s8.3-17,5.48-17.84c-3.68-1.14-8.77,14.17-9.29,15.43s-2.35.49-1.81-.62c.77-1.59,8.43-18.58,4.82-19.73-2-.63-2.72,3.11-2.72,3.11s-6,16.45-7.69,15.85,1.5-10.39,2.81-13.61.33-5.13-1.54-4.57c-1.28.38-5.53,10.14-6.75,13.35s-4.42,12.1-6.36,6.35c0-.09-.07-.17-.11-.26-1.75-5.72-5-9.54-6.69-10s-2.92,1.4-2.22,3a2,2,0,0,0,.44.75c.09.1.18.25.27.36a30,30,0,0,1,2.44,5.62,16.29,16.29,0,0,1,.87,5.4c0,2.13,1,8.33.92,9.86"
          style={{
            fill: 'rgb(255, 173, 157)',
            transformOrigin: '534.6092109680176px 329.53422927856445px',
          }}
          id="elfywhno0iy0e"
          className="animable"
        />
        <path
          d="M518,342l-24.19,48s-13.68-39.57-21.06-55.31c-2.81-6-8.45-10.16-13.86-12.92v-.11l-1.13-.45A57.28,57.28,0,0,0,445.6,317c-25.52-7.31-49.56-4.76-77.39,5,0,0-14.45,3.88-21.46,22.73-6.3,17-13.37,43-14.58,47.6-8.67,29.18,3.71,45.43,20.94,43.43,7.1-1.12,13.14-7,15.81-9.28l9.11-8.56.2,6.63L368,465.5l104.74-.22-18.9-48.49,4.2-22.23,7.19,17.08a29.93,29.93,0,0,0,54.87.71l24.49-61.66Z"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '436.9601058959961px 389.14459228515625px',
          }}
          id="elr0xs5fwecs"
          className="animable"
        />
        <path
          d="M391.87,401.84a10.29,10.29,0,0,1-.94,1.35c-.63.84-1.58,2.05-2.79,3.5-2.41,2.91-5.88,6.82-9.91,10.95s-7.87,7.68-10.75,10.13c-1.43,1.24-2.62,2.2-3.46,2.84a8.63,8.63,0,0,1-1.34,1,10.2,10.2,0,0,1,1.21-1.11c.8-.69,1.95-1.7,3.35-3,2.8-2.53,6.59-6.11,10.61-10.23s7.54-8,10-10.82c1.25-1.42,2.23-2.59,2.91-3.39A9.5,9.5,0,0,1,391.87,401.84Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '377.27500915527344px 416.7250061035156px',
          }}
          id="elwoeqvt2a0le"
          className="animable"
        />
        <path
          d="M454.18,415.23a2.16,2.16,0,0,1,.05-.56c.08-.42.16-.94.27-1.58l1.09-5.82c.92-4.91,2.18-11.69,3.18-19.24q.38-2.83.68-5.51a29.32,29.32,0,0,0,.29-5.13,51.49,51.49,0,0,0-1.29-8.63c-.54-2.44-1-4.4-1.31-5.77-.14-.69-.22-1.23-.26-1.59a2.24,2.24,0,0,1,0-.57,2.17,2.17,0,0,1,.12.55c.07.36.19.89.36,1.57.33,1.35.88,3.29,1.47,5.73a48.53,48.53,0,0,1,1.41,8.69,30.82,30.82,0,0,1-.26,5.2c-.19,1.79-.42,3.64-.67,5.53-1,7.57-2.33,14.35-3.34,19.24-.52,2.39-.94,4.35-1.25,5.79-.15.63-.27,1.15-.36,1.57A2.81,2.81,0,0,1,454.18,415.23Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '457.21825647354126px 388.03001403808594px',
          }}
          id="el2734cty0b78"
          className="animable"
        />
        <path
          d="M491.68,401.74a67.8,67.8,0,0,1,2.17-11.66A34.17,34.17,0,0,1,493,396,34.71,34.71,0,0,1,491.68,401.74Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '492.7649841308594px 395.9099884033203px',
          }}
          id="elhp00a6hyvq"
          className="animable"
        />
        <path
          d="M495.37,403.16a45.47,45.47,0,0,1-1-6.75,44.65,44.65,0,0,1-.53-6.81,45.47,45.47,0,0,1,1,6.75A44.65,44.65,0,0,1,495.37,403.16Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '494.6050109863281px 396.37998962402344px',
          }}
          id="elrl9smdtre5g"
          className="animable"
        />
        <path
          d="M418.11,465.28c-.14,0-.26-16.08-.26-35.9s.12-35.91.26-35.91.26,16.07.26,35.91S418.25,465.28,418.11,465.28Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '418.1099853515625px 429.375px',
          }}
          id="elykhu3f16rqd"
          className="animable"
        />
        <g id="elm7v4jbmpzv">
          <g
            style={{
              opacity: '0.2',
              transformOrigin: '462.40000915527344px 389.74597358703613px',
            }}
            className="animable"
          >
            <path
              d="M457.41,363.73c4.91,9.41,9.18,18.77,9.57,29.38.3,8.25-3,15.13.41,22.65-.17.13-3.08-6.35-4.37-9.39-2.65-6.26-5-11.85-5-11.85s1.82-14.13,2-16.54S457.41,363.73,457.41,363.73Z"
              id="elhsxa6ee046e"
              style={{
                transformOrigin: '462.40000915527344px 389.74597358703613px',
              }}
              className="animable"
            />
          </g>
        </g>
        <g id="elyxtikftmpd">
          <g
            style={{
              opacity: '0.2',
              transformOrigin: '353.41982078552246px 387.03102111816406px',
            }}
            className="animable"
          >
            <path
              d="M335.88,411.54c0,4.72-2.93-10.86-.19-14.69,1.93-2.69,5.23-4,8.43-4.79s6.55-1.32,9.39-3c3.67-2.17,6-6,8.57-9.36s6-17.75,10.24-18.06v21a285.83,285.83,0,0,1-31.62,17.73A14.73,14.73,0,0,0,335.88,411.54Z"
              id="el54geasys4cp"
              style={{
                transformOrigin: '353.41982078552246px 387.03102111816406px',
              }}
              className="animable"
            />
          </g>
        </g>
        <g id="eln4n4185cqkn">
          <g
            style={{
              opacity: '0.2',
              transformOrigin: '399.125px 406.6650085449219px',
            }}
            className="animable"
          >
            <path
              d="M378,417.93c6.85-3.85,11.85-9,19.59-10.33,7.45-1.32,15.12,0,22.66-.52q-.61-5.71-1.25-11.44l-21.57-.24Z"
              id="elgwmov2h8x5w"
              style={{ transformOrigin: '399.125px 406.6650085449219px' }}
              className="animable"
            />
          </g>
        </g>
        <path
          d="M372.32,361.4c.14,0,.26,4.67.26,10.43s-.12,10.44-.26,10.44a102.68,102.68,0,0,1-.26-10.44A102.55,102.55,0,0,1,372.32,361.4Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '372.30267667770386px 371.8349609375px',
          }}
          id="elfa8kjw6ksn4"
          className="animable"
        />
        <path
          d="M335.86,411.43a4.77,4.77,0,0,1-.12-1.86,13.2,13.2,0,0,1,1.06-4.37,13,13,0,0,1,2.45-3.76,5,5,0,0,1,1.42-1.2,24.1,24.1,0,0,0-3.39,5.17A22.68,22.68,0,0,0,335.86,411.43Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '338.1841685771942px 405.8349914550781px',
          }}
          id="elzkmo449nac8"
          className="animable"
        />
        <path
          d="M340.17,400.56a9.41,9.41,0,0,0,1.57-.57c1-.4,2.44-1,4.19-1.83,3.5-1.6,8.27-4,13.33-7s9.47-5.95,12.56-8.21c1.55-1.14,2.79-2.08,3.62-2.75a9.93,9.93,0,0,0,1.26-1.09,10.15,10.15,0,0,0-1.4.92l-3.71,2.6c-3.15,2.18-7.57,5.09-12.62,8.06s-9.77,5.39-13.22,7.08l-4.1,2A9.44,9.44,0,0,0,340.17,400.56Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '358.4349822998047px 389.8349914550781px',
          }}
          id="eltfnwenb42wl"
          className="animable"
        />
        <path
          d="M471.57,271.82c-1.72-2.25-4.45-4-5-6.75-.69-3.69,3-7.15,2.33-10.85-.44-2.53-2.77-4.31-5.15-5.29s-5-1.45-7.18-2.76a14.51,14.51,0,0,1-5.73-7.06,24.15,24.15,0,0,1-.85-2.43,25.79,25.79,0,0,0-1.21-5.19c-.09-.44-.17-.88-.25-1.32l.11,1a10.51,10.51,0,0,0-1.3-2.34c-1.83-2.44-5.49-3.8-8-2.09l1.2-.8a23.09,23.09,0,0,0-17.83-14,21.35,21.35,0,0,0-4.52-.15c-5.39-.28-13.18,1.29-16.47,3.38-4.2,2.66-8.5,6.31-10.61,10.82-1.13,2.43-1.9,5.24-4,6.86-2.86,2.16-6.87,1.32-10.44,1.72-5.88.67-11,5.18-13,10.75a21.43,21.43,0,0,0,1.64,17.17c.62,1.15,1.35,2.48.86,3.69a4.64,4.64,0,0,1-2.25,2,12.09,12.09,0,0,0-5.44,5.69c-1,2.49-.62,5.64,1.4,7.4a6.08,6.08,0,0,0,6.1.87,13.27,13.27,0,0,0-.93,4.73,9.9,9.9,0,0,0,4.91,8.79c3.13,1.63,7.51.77,9.35-2.24a12.3,12.3,0,0,0,19,10.38c1.48-1,3-2.32,4.75-2s2.74,2,3.94,3.22c3.2,3.33,8.66,3.71,12.87,1.82s7.31-5.67,9.54-9.71a7.44,7.44,0,0,0,13.27-1.86,12.44,12.44,0,0,0,22.27-7.06,10.22,10.22,0,0,0,6.63-16.31ZM371,274.91s0,0,0-.06l.1-.05Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '415.8119125366211px 259.85427474975586px',
          }}
          id="el652t07zm3tr"
          className="animable"
        />
        <path
          d="M434.44,300s12.81-2.12,15.46-18.83c1.32-8.31.9-21.93.2-33.06a17.65,17.65,0,0,0-19.46-16.45l-29,3.07a5.88,5.88,0,0,0-5.26,6l3.05,72.58c-2.11.45-6.9,1.49-9.25,2.17,0,0,22.42,50.11,27.91,49.53s27.43-48,27.43-48a114.63,114.63,0,0,0-11.62-2.85A138.21,138.21,0,0,1,434.44,300Z"
          style={{
            fill: 'rgb(255, 173, 157)',
            transformOrigin: '420.46985244750977px 298.28916931152344px',
          }}
          id="eldngcbnm8af"
          className="animable"
        />
        <path
          d="M443.62,257.21a2.14,2.14,0,0,1-2.06,2.16,2,2,0,0,1-2.21-1.93,2.14,2.14,0,0,1,2.06-2.16A2.05,2.05,0,0,1,443.62,257.21Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '441.48498797416687px 257.32731318473816px',
          }}
          id="elegk6gn3v0yr"
          className="animable"
        />
        <path
          d="M447.15,255.23c-.27.28-1.89-.92-4.2-.91s-4,1.16-4.24.88c-.13-.13.14-.63.88-1.17A6,6,0,0,1,443,253a5.68,5.68,0,0,1,3.34,1.08C447,254.6,447.28,255.11,447.15,255.23Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '442.92980575561523px 254.13609409332275px',
          }}
          id="el8ddinz77unl"
          className="animable"
        />
        <path
          d="M421.37,257.64a2.14,2.14,0,0,1-2.07,2.16,2,2,0,0,1-2.21-1.93,2.14,2.14,0,0,1,2.07-2.16A2.05,2.05,0,0,1,421.37,257.64Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '419.2300109863281px 257.7573494911194px',
          }}
          id="el1vktyd0lf3i"
          className="animable"
        />
        <path
          d="M424.48,255.66c-.26.28-1.89-.92-4.19-.91s-4,1.16-4.25.88c-.12-.13.15-.63.89-1.17a5.94,5.94,0,0,1,3.4-1.05,5.7,5.7,0,0,1,3.34,1.08C424.37,255,424.61,255.54,424.48,255.66Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '420.2631950378418px 254.5561567544937px',
          }}
          id="el7b33exbvro7"
          className="animable"
        />
        <path
          d="M432.85,272.76a15.1,15.1,0,0,1,3.75-.67c.58-.06,1.14-.18,1.24-.58a3,3,0,0,0-.39-1.75c-.56-1.42-1.13-2.92-1.74-4.48-2.42-6.38-4.17-11.63-3.91-11.73s2.42,5,4.84,11.39l1.67,4.51a3.36,3.36,0,0,1,.3,2.31,1.46,1.46,0,0,1-1,.86,4.42,4.42,0,0,1-1,.14A15.25,15.25,0,0,1,432.85,272.76Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '435.23448157310486px 263.2124252319336px',
          }}
          id="elajwhseketq"
          className="animable"
        />
        <path
          d="M434.44,300a42.48,42.48,0,0,1-22.37-6s5.43,11.47,22.15,9.91Z"
          style={{
            fill: 'rgb(237, 148, 130)',
            transformOrigin: '423.2550048828125px 299.0279030799866px',
          }}
          id="eltkskg86ggxc"
          className="animable"
        />
        <path
          d="M426.36,276.37a4.53,4.53,0,0,1,1.69-.73,1.49,1.49,0,0,1,1.57.74,3.72,3.72,0,0,0,.24.58c.34.46,1.05.29,1.59.45a1.68,1.68,0,0,1,.89,2.21,3.38,3.38,0,0,1-2,1.72,7.17,7.17,0,0,1-3.58.49,3,3,0,0,1-2.21-1.1,2.62,2.62,0,0,1,.17-2.86,7.63,7.63,0,0,1,2.29-2"
          style={{
            fill: 'rgb(237, 148, 130)',
            transformOrigin: '428.3405132293701px 278.7479598522186px',
          }}
          id="el5ul76rizmul"
          className="animable"
        />
        <path
          d="M426.07,274.36c.37,0,.38,2.48,2.52,4.25s4.8,1.5,4.82,1.85c0,.16-.59.49-1.72.52a6.24,6.24,0,0,1-4-1.4,5.46,5.46,0,0,1-2-3.57C425.62,275,425.9,274.34,426.07,274.36Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '429.54449343681335px 277.6699261665344px',
          }}
          id="el7yv712ur4y5"
          className="animable"
        />
        <path
          d="M425.52,251.63c-.23.62-2.53.33-5.23.65s-4.9,1.07-5.25.5c-.16-.26.22-.85,1.1-1.46a9.19,9.19,0,0,1,8-.88C425.12,250.84,425.62,251.33,425.52,251.63Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '420.2684383392334px 251.445099234581px',
          }}
          id="elcx54cind8r5"
          className="animable"
        />
        <path
          d="M446.3,250c-.41.53-2,0-3.91,0s-3.52.35-3.89-.2c-.17-.26.09-.79.79-1.28a5.66,5.66,0,0,1,6.29.19C446.26,249.23,446.48,249.77,446.3,250Z"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '442.4048705101013px 248.94663453102112px',
          }}
          id="el19kej04jyty"
          className="animable"
        />
        <path
          d="M440.33,229.22a22.66,22.66,0,0,1-27.42,17.37,21.53,21.53,0,0,1-12.69,16.9A45.86,45.86,0,0,1,405.61,291c-.49,4-1.66,8.27-4.7,11-4.64,4.16-12.46,3.15-16.92-1.19-4.28-4.17-5.79-10.69-4.58-16.54s4.88-11,9.49-14.76a10.59,10.59,0,0,1-5.46-18.16c1.31-1.24,3-2.16,4-3.67s1.16-3.19,1.73-4.8c1.49-4.21,5.25-7.12,8.83-9.8,3-2.26,6.36-4.62,10.14-4.61,2,0,4,.7,6,.43,2.75-.37,4.9-2.46,7.17-4a15.62,15.62,0,0,1,11-3c3.87.61,7.48,3.5,8.21,7.34"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '409.7633972167969px 263.22768783569336px',
          }}
          id="elvbnc7ho13y"
          className="animable"
        />
        <path
          d="M438.84,230.87c-.59,3.23,1,6.54,3.42,8.8s5.41,3.66,8.4,5a38.08,38.08,0,0,0-4.33-9,12.72,12.72,0,0,0-8.12-5.48"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '444.4350128173828px 237.4300079345703px',
          }}
          id="ely4hcp21sgxc"
          className="animable"
        />
        <path
          d="M365.36,269.39a2.21,2.21,0,0,1-.09-1.05,4,4,0,0,1,1.5-2.58,6.64,6.64,0,0,1,4.56-1.24c1.87,0,3.94.62,6.23.48a7.88,7.88,0,0,0,6.08-3.77,8,8,0,0,0,1.14-3.93c.1-1.43,0-2.93.05-4.49a8.12,8.12,0,0,1,1.46-4.57,9.49,9.49,0,0,1,4-3c3.15-1.43,6.74-1.45,10.18-2.09a14.79,14.79,0,0,0,4.86-1.7,13,13,0,0,0,3.61-3.43c1.95-2.68,3.26-5.67,5.05-8.22a17.21,17.21,0,0,1,20.24-6.55,17,17,0,0,1,4.21,2.23,13.27,13.27,0,0,1,2.95,2.78,1.24,1.24,0,0,1-.2-.18l-.55-.55a19.06,19.06,0,0,0-2.31-1.88A17.51,17.51,0,0,0,428,222.56a17.18,17.18,0,0,0-13.63,7.52c-1.75,2.5-3.05,5.49-5,8.25a13.33,13.33,0,0,1-3.76,3.56,15,15,0,0,1-5,1.77c-3.52.65-7,.67-10.08,2a9.13,9.13,0,0,0-3.8,2.84,7.58,7.58,0,0,0-1.38,4.3c-.09,1.51,0,3-.07,4.49a8.53,8.53,0,0,1-1.23,4.13,8.22,8.22,0,0,1-6.42,3.9c-2.39.12-4.45-.5-6.28-.55a6.42,6.42,0,0,0-4.42,1.11,4,4,0,0,0-1.52,2.44A4.26,4.26,0,0,0,365.36,269.39Z"
          style={{
            fill: 'rgb(250, 250, 250)',
            transformOrigin: '403.3166809082031px 245.7878074645996px',
          }}
          id="elo4p1l4fm31"
          className="animable"
        />
        <polygon
          points="390.2 346.58 391.26 373.22 393.94 398.72 422.27 397.51 420.23 347.16 390.2 346.58"
          style={{
            fill: 'rgb(38, 50, 56)',
            transformOrigin: '406.23500061035156px 372.6499938964844px',
          }}
          id="elv3roamy4bab"
          className="animable"
        />
        <polygon
          points="386.04 346.49 387.1 373.22 389.78 398.72 418.11 397.51 416.07 347.08 386.04 346.49"
          style={{
            fill: 'rgb(69, 90, 100)',
            transformOrigin: '402.0749969482422px 372.60499572753906px',
          }}
          id="elyabr9wv6n3r"
          className="animable"
        />
        <path
          d="M383.38,401.84a184.81,184.81,0,0,0,22.43-2.4c8.78-1.41,8.69-2.2,8.38-3.21-.84-2.7-15.54,1.88-12.9-.94s18.57-3.5,17.57-6.28c-1.29-3.63-16.6,1.45-17.92,1.78s-1.8-1.58-.59-1.82c1.74-.34,19.93-4.36,18.69-7.94-.68-2-4.11-.32-4.11-.32s-16.78,5-17.31,3.33,9.23-5,12.59-5.9,4.31-2.81,2.74-4c-1.07-.79-11.43,1.64-14.73,2.59s-12.34,3.69-8.9-1.31c.06-.08.1-.16.15-.24,3.53-4.82,4.64-9.71,4-11.35s-2.87-1.49-3.72,0a2.13,2.13,0,0,0-.34.8c0,.13-.09.3-.13.44a30,30,0,0,1-3,5.31,16,16,0,0,1-3.81,3.93c-1.71,1.25-6,5.83-7.35,6.64"
          style={{
            fill: 'rgb(255, 173, 157)',
            transformOrigin: '397.1102867126465px 382.247766494751px',
          }}
          id="elf0u6onmclia"
          className="animable"
        />
        <polygon
          points="376.89 379.48 391.87 401.84 367.18 427.02 368.02 386.18 376.89 379.48"
          style={{
            fill: 'rgb(149, 189, 81)',
            transformOrigin: '379.5249938964844px 403.25px',
          }}
          id="el8sa607ho0sx"
          className="animable"
        />
      </g>
      <defs>
        <filter id="active" height="200%">
          <feMorphology
            in="SourceAlpha"
            result="DILATED"
            operator="dilate"
            radius={2}
          />
          <feFlood floodColor="#32DFEC" floodOpacity={1} result="PINK" />
          <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
          <feMerge>
            <feMergeNode in="OUTLINE" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <filter id="hover" height="200%">
          <feMorphology
            in="SourceAlpha"
            result="DILATED"
            operator="dilate"
            radius={2}
          />
          <feFlood floodColor="#ff0000" floodOpacity="0.5" result="PINK" />
          <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
          <feMerge>
            <feMergeNode in="OUTLINE" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
          <feColorMatrix
            type="matrix"
            values="0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
          />
        </filter>
      </defs>
    </svg>
  );
};

export default AboutUsThread;

AboutUsThread.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
};
